/**
 * Complete Authentic Tamil Translations for MyMenuBuddy Recipes (All 45 Dishes)
 */

export const STATE_TAMIL_MAP = {
  "Tamil Nadu": "தமிழ்நாடு",
  "Tamil Nadu / South India": "தமிழ்நாடு / தென்னிந்தியா",
  "Kerala": "கேரளா",
  "Andhra Pradesh": "ஆந்திர பிரதேசம்",
  "Karnataka": "கர்நாடகா",
  "Punjab": "பஞ்சாப்",
  "Maharashtra": "மகாராஷ்டிரா",
  "Delhi / Punjab": "டெல்லி / பஞ்சாப்",
  "North India": "வட இந்தியா",
  "Tamil Nadu / Kerala": "தமிழ்நாடு / கேரளா",
  "Indo-Chinese": "இண்டோ-சைனீஸ்",
  "West Bengal": "மேற்கு வங்காளம்",
  "Punjab / Delhi": "பஞ்சாப் / டெல்லி",
  "India Healthy": "பாரம்பரிய ஆரோக்கியம்",
  "Central Thailand": "தாய்லாந்து",
  "Kanto": "ஜப்பான்",
  "Beirut Governorate": "லெபனான் / மத்திய கிழக்கு",
  "Central Mexico": "மெக்சிகோ",
  "Campania": "இத்தாலி",
  "Lazio": "இத்தாலி",
  "Global": "சர்வதேசம்",
  "Tamil Nadu / Telangana": "தமிழ்நாடு / தெலங்கானா",
  "Kerala / Tamil Nadu": "கேரளா / தமிழ்நாடு"
};

export const CUISINE_TAMIL_MAP = {
  "Tamil Nadu Breakfast": "தமிழ்நாடு காலை உணவு",
  "Tamil Nadu Traditional": "தமிழ்நாடு பாரம்பரியம்",
  "Temple Style Breakfast": "கோவில் பாணி காலை உணவு",
  "South Indian Breakfast": "தென்னிந்திய காலை உணவு",
  "Kerala Syrian Christian": "கேரளா பாரம்பரியம்",
  "Andhra Breakfast": "ஆந்திரா காலை உணவு",
  "Karnataka Tiffin": "கர்நாடகா டிபன்",
  "Punjabi Breakfast": "பஞ்சாபி காலை உணவு",
  "Maharashtrian Breakfast": "மகாராஷ்டிரா காலை உணவு",
  "Tamil Nadu Comfort Food": "தமிழ்நாடு ஸ்பெஷல்",
  "Kongunadu": "கொங்குநாடு பாரம்பரியம்",
  "Tirunelveli Traditional": "திருநெல்வேலி பாரம்பரியம்",
  "Madurai Street Food": "மதுரை ஸ்பெஷல்",
  "Chettinad Non-Veg": "செட்டிநாடு அசைவம்",
  "Royal Biryani": "ராயல் பிரியாணி",
  "Coastal Seafood": "கடலோர மீன் உணவு",
  "North Indian Dhaba": "வட இந்திய தாபா உணவு",
  "Punjabi Comfort Food": "பஞ்சாபி பாரம்பரியம்",
  "Andhra Spicy": "ஆந்திரா கார உணவு",
  "North Indian Homestyle": "வட இந்திய வீட்டு உணவு",
  "Mughlai North Indian": "முகலாய் வட இந்திய உணவு",
  "Street Tiffin Classic": "ரோட்டுக்கடை டிபன்",
  "Italian Classic": "இத்தாலியன் உணவு",
  "Italian Pasta": "இத்தாலியன் பாஸ்தா",
  "Indo-Chinese": "இண்டோ-சைனீஸ்",
  "Indo-Chinese Non-Veg": "இண்டோ-சைனீஸ் அசைவம்",
  "Thai Street Food": "தாய்லாந்து உணவு",
  "Japanese Ramen": "ஜப்பானிய ரேமன்",
  "Middle Eastern": "மத்திய கிழக்கு உணவு",
  "Mumbai Street Food": "மும்பை ஸ்ட்ரீட் ஃபுட்",
  "Punjabi Street Food": "பஞ்சாபி ஸ்ட்ரீட் ஃபுட்",
  "Mexican Traditional": "மெக்சிகன் உணவு",
  "Evening Tea Snack": "மாலை நேர டீ ஸ்நாக்ஸ்",
  "Kanyakumari Coastal": "கன்னியாகுமரி கடலோர உணவு",
  "Kerala Seafood Classic": "கேரளா கடல் உணவு",
  "Kerala Non-Veg Breakfast": "கேரளா அசைவ காலை உணவு",
  "Kerala Traditional": "கேரளா பாரம்பரியம்",
  "Sadhya Classic": "கேரளா சத்யா விருந்து",
  "High Protein Dinner": "அதிக புரத இரவு உணவு",
  "Temple Snack & Tea Time": "கோவில் பலகாரம்",
  "Military Mess Classic": "மிலிட்டரி மெஸ் அசைவம்",
  "Wholesome Millet Classic": "சத்துமிக்க சிறுதானிய உணவு",
  "Fiber Rich Breakfast": "நார்ச்சத்து நிறைந்த காலை உணவு"
};

export const TAMIL_RECIPES = {
  "1": {
    "meal_ta": "மல்லிகைப் பூ இட்லி + கதம்ப சாம்பார் + தேங்காய் சட்னி",
    "desc_ta": "பஞ்சு போன்ற மெதுவான இட்லியுடன் நறுமணமிக்க பருப்பு சாம்பார் மற்றும் காரசாரமான கெட்டி தேங்காய் சட்னி.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "தமிழ்நாடு காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "மல்லிகைப் பூ மெதுவான இட்லி",
        "ingredients_ta": [
          [
            "இட்லி அரிசி",
            "2 கப்"
          ],
          [
            "முழு உளுத்தம் பருப்பு",
            "1/2 கப்"
          ],
          [
            "வெந்தயம்",
            "1 தேக்கரண்டி"
          ],
          [
            "கல் உப்பு",
            "1 தேக்கரண்டி"
          ],
          [
            "தண்ணீர்",
            "தேவையான அளவு"
          ]
        ],
        "quick_ta": "அரிசி மற்றும் உளுந்தை தனித்தனியாக 4 மணி நேரம் ஊறவைக்கவும்|உளுந்தை பஞ்சு போலவும் அரிசியை ரவை பதத்திலும் அரைக்கவும்|8-10 மணி நேரம் மாவை புளிக்க வைக்கவும்|இட்லி தட்டில் ஊற்றி 10 நிமிடம் ஆவியில் வேகவைக்கவும்"
      },
      {
        "name_ta": "சுடச்சுட காய்கறி சாம்பார்",
        "ingredients_ta": [
          [
            "துவரம் பருப்பு",
            "1/2 கப்"
          ],
          [
            "முருங்கைக்காய், கேரட், சின்ன வெங்காயம்",
            "1.5 கப்"
          ],
          [
            "தக்காளி",
            "1 நறுக்கியது"
          ],
          [
            "புளிக்கரைசல்",
            "2 மேஜைக்கரண்டி"
          ],
          [
            "சாம்பார் பொடி",
            "1.5 மேஜைக்கரண்டி"
          ],
          [
            "மஞ்சள் தூள் & பெருங்காயம்",
            "1/4 தேக்கரண்டி"
          ],
          [
            "கடுகு & கறிவேப்பிலை",
            "தாளிக்க"
          ],
          [
            "நெய்/எண்ணெய்",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "துவரம் பருப்பை மஞ்சள் தூள் சேர்த்து குக்கரில் குழைய வேகவைக்கவும்|காய்கறிகளை புளித்தண்ணீர், சாம்பார் பொடி மற்றும் உப்பு சேர்த்து கொதிக்க வைக்கவும்|வெந்த பருப்பை சேர்த்து 5 நிமிடம் கொதிக்கவிடவும்|நெய்யில் கடுகு, பெருங்காயம், கறிவேப்பிலை தாளித்துக் கொட்டவும்"
      },
      {
        "name_ta": "கெட்டி தேங்காய் சட்னி",
        "ingredients_ta": [
          [
            "துருவிய தேங்காய்",
            "1 கப்"
          ],
          [
            "பொட்டுக்கடலை",
            "2 மேஜைக்கரண்டி"
          ],
          [
            "பச்சை மிளகாய்",
            "2"
          ],
          [
            "இஞ்சி",
            "சிறிய துண்டு"
          ],
          [
            "கடுகு & கறிவேப்பிலை",
            "தாளிக்க"
          ],
          [
            "உப்பு",
            "1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "தேங்காய், பொட்டுக்கடலை, பச்சை மிளகாய், இஞ்சி மற்றும் உப்பு சேர்த்து அரைக்கவும்|சூடான நல்லெண்ணெயில் கடுகு, கறிவேப்பிலை தாளித்து கலக்கவும்"
      }
    ]
  },
  "2": {
    "meal_ta": "மொறுமொறு நெய் தோசை + சாம்பார் + காரத் தக்காளி சட்னி",
    "desc_ta": "பொன்னிறமாக சுட்ட மொறுமொறுப்பான தோசையுடன் காய்கறி சாம்பார் மற்றும் சுவையான தக்காளி வெங்காய காரச்சட்னி.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "தமிழ்நாடு பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "மொறுமொறுப்பான நெய் தோசை",
        "ingredients_ta": [
          [
            "தோசை மாவு",
            "2 கப்"
          ],
          [
            "நல்லெண்ணெய் / நெய்",
            "2 மேஜைக்கரண்டி"
          ],
          [
            "தண்ணீர்",
            "தேவையான அளவு"
          ]
        ],
        "quick_ta": "தோசைக் கல்லை சூடாக்கி மாவை மெல்லியதாக வட்டமாக தேய்க்கவும்|சுற்றிலும் நெய் அல்லது நல்லெண்ணெய் விடவும்|அடிப்புறம் பொன்னிறமாக மொறுமொறுவென வேகும் வரை வேகவைத்து மடித்து எடுக்கவும்"
      },
      {
        "name_ta": "காரத் தக்காளி வெங்காய சட்னி",
        "ingredients_ta": [
          [
            "தக்காளி",
            "2 நறுக்கியது"
          ],
          [
            "வெங்காயம்",
            "1 நறுக்கியது"
          ],
          [
            "பூண்டு",
            "4 பல்"
          ],
          [
            "காய்ந்த மிளகாய்",
            "4"
          ],
          [
            "கடுகு & கறிவேப்பிலை",
            "தாளிக்க"
          ],
          [
            "நல்லெண்ணெய்",
            "1.5 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "வெங்காயம், பூண்டு, காய்ந்த மிளகாய், தக்காளி ஆகியவற்றை எண்ணெயில் வதக்கவும்|ஆறியதும் உப்பு சேர்த்து நைசாக அரைக்கவும்|கடுகு, கறிவேப்பிலை தாளிக்கவும்"
      }
    ]
  },
  "3": {
    "meal_ta": "நெய் வெண் பொங்கல் + மெது வடை + சாம்பார்",
    "desc_ta": "மிளகு, சீரகம், இஞ்சி, முந்திரி மணக்கும் நெய் வழியும் வெண் பொங்கல் மற்றும் மொறுமொறுப்பான மெது வடை.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "கோவில் பாணி காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "கோவில் நெய் வெண் பொங்கல்",
        "ingredients_ta": [
          [
            "பச்சரிசி",
            "1 கப்"
          ],
          [
            "பாசிப்பருப்பு",
            "1/2 கப் வறுத்தது"
          ],
          [
            "சுத்தமான நெய்",
            "4 மேஜைக்கரண்டி"
          ],
          [
            "மிளகு",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "சீரகம்",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "இஞ்சி",
            "1 மேஜைக்கரண்டி பொடியாக நறுக்கியது"
          ],
          [
            "முந்திரி",
            "12"
          ],
          [
            "கறிவேப்பிலை & பெருங்காயம்",
            "கைப்பிடி & 1/4 தேக்கரண்டி"
          ],
          [
            "உப்பு",
            "1.5 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "பாசிப்பருப்பை வறுத்து அரிசியுடன் 4.5 கப் தண்ணீர் சேர்த்து குழைய வேகவைக்கவும்|நெய்யில் முந்திரி, மிளகு, சீரகம், இஞ்சி, பெருங்காயம், கறிவேப்பிலை பொன்னிறமாக வறுக்கவும்|சூடான நெய் தாளிப்பை பொங்கலில் ஊற்றி நன்றாக கலக்கவும்"
      },
      {
        "name_ta": "மொறுமொறு மெது வடை",
        "ingredients_ta": [
          [
            "முழு உளுத்தம் பருப்பு",
            "1 கப் ஊறவைத்தது"
          ],
          [
            "பச்சை மிளகாய் & இஞ்சி",
            "தலா 1 தேக்கரண்டி"
          ],
          [
            "மிளகு",
            "1 தேக்கரண்டி"
          ],
          [
            "கறிவேப்பிலை & பெருங்காயம்",
            "தேவையான அளவு"
          ],
          [
            "எண்ணெய்",
            "பொரிக்க"
          ],
          [
            "உப்பு",
            "1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "ஊறிய உளுந்தை சிறிதளவு தண்ணீர் தெளித்து பஞ்சு போல கெட்டியாக அரைக்கவும்|மிளகாய், இஞ்சி, மிளகு, கறிவேப்பிலை சேர்த்து கலக்கவும்|கையில் நடுவில் ஓட்டை போட்டு சூடான எண்ணெயில் பொன்னிறமாக பொரித்தெடுக்கவும்"
      }
    ]
  },
  "4": {
    "meal_ta": "உப்பிய பூரி + ஹோட்டல் ஸ்டைல் உருளைக்கிழங்கு மசாலா",
    "desc_ta": "பொன்னிறமாக உப்பிய கோதுமை பூரியுடன் மஞ்சள் நிற சுவையான உருளைக்கிழங்கு மசாலா.",
    "state_ta": "தமிழ்நாடு / தென்னிந்தியா",
    "cuisine_ta": "தென்னிந்திய காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "பொன்னிற உப்பிய பூரி",
        "ingredients_ta": [
          [
            "கோதுமை மாவு",
            "2 கப்"
          ],
          [
            "ரவை",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "தண்ணீர்",
            "3/4 கப்"
          ],
          [
            "எண்ணெய்",
            "பொரிக்க"
          ],
          [
            "உப்பு",
            "1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "கோதுமை மாவு, ரவை, உப்பு சேர்த்து கெட்டியாக பிசையவும்|சிறிய உருண்டைகளாக தேய்க்கவும்|சூடான எண்ணெயில் போட்டு கரண்டியால் லேசாக அழுத்தினால் பலூன் போல உப்பும்; திருப்பிப் போட்டு எடுக்கவும்"
      },
      {
        "name_ta": "ஹோட்டல் உருளைக்கிழங்கு மசாலா",
        "ingredients_ta": [
          [
            "வேகவைத்த உருளைக்கிழங்கு",
            "3 பெரியது"
          ],
          [
            "வெங்காயம்",
            "2 நீளமாக நறுக்கியது"
          ],
          [
            "பச்சை மிளகாய்",
            "3"
          ],
          [
            "இஞ்சி",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "கடலை மாவு கரைசல்",
            "1 மேஜைக்கரண்டி"
          ],
          [
            "மஞ்சள் தூள்",
            "1/2 தேக்கரண்டி"
          ],
          [
            "கடுகு & உளுத்தம் பருப்பு",
            "1/2 தேக்கரண்டி"
          ],
          [
            "எண்ணெய்",
            "1.5 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "எண்ணெயில் கடுகு, உளுந்து, இஞ்சி, பச்சை மிளகாய், வெங்காயம் வதக்கவும்|மஞ்சள் தூள், மசித்த உருளைக்கிழங்கு, தண்ணீர், உப்பு சேர்த்து கொதிக்கவிடவும்|கடலை மாவு கரைசலை ஊற்றி கெட்டியாக கொதிக்கவைத்து கொத்தமல்லி தூவி இறக்கவும்"
      }
    ]
  },
  "5": {
    "meal_ta": "ஆப்பம் + தேங்காய்ப்பால் காய்கறி ஸ்டூ",
    "desc_ta": "பஞ்சு போன்ற மெதுவான நடுப்பகுதியும் மொறுமொறு விளிம்புகளும் கொண்ட ஆப்பம் மற்றும் மணமணக்கும் தேங்காய்ப்பால் காய்கறி ஸ்டூ.",
    "state_ta": "கேரளா",
    "cuisine_ta": "கேரளா பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "மெதுவான பஞ்சு ஆப்பம்",
        "ingredients_ta": [
          [
            "பச்சரிசி",
            "2 கப்"
          ],
          [
            "துருவிய தேங்காய்",
            "1 கப்"
          ],
          [
            "சாதம்",
            "1/2 கப்"
          ],
          [
            "ஈஸ்ட் / ஆப்ப சோடா",
            "1/2 தேக்கரண்டி"
          ],
          [
            "சர்க்கரை & உப்பு",
            "1 மேஜைக்கரண்டி & 1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "அரிசி, தேங்காய், சாதம் சேர்த்து நைசாக அரைத்து புளிக்க வைக்கவும்|ஆப்பச் சட்டியில் மாவை ஊற்றி சுழற்றி மூடி 2 நிமிடம் வேகவைத்து எடுக்கவும்"
      },
      {
        "name_ta": "கேரளா காய்கறி தேங்காய்ப்பால் ஸ்டூ",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு, கேரட், பட்டாணி",
            "2 கப்"
          ],
          [
            "தேங்காய்ப்பால் (முதல் & இரண்டாம் பால்)",
            "1 கப் & 2 கப்"
          ],
          [
            "பச்சை மிளகாய், இஞ்சி, வெங்காயம்",
            "வதக்க"
          ],
          [
            "பட்டை, கிராம்பு, ஏலக்காய்",
            "தாளிக்க"
          ],
          [
            "தேங்காய் எண்ணெய்",
            "2 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "தேங்காய் எண்ணெயில் மசாலா பொருட்கள், வெங்காயம், இஞ்சி, மிளகாய் வதக்கவும்|இரண்டாம் தேங்காய்ப்பாலில் காய்கறிகளை வேகவைக்கவும்|கடைசியாக திக்கான முதல் பால் ஊற்றி லேசாக சூடானதும் இறக்கவும்"
      }
    ]
  },
  "6": {
    "meal_ta": "ஆந்திரா பெசரட்டு + அல்லம் (இஞ்சி) சட்னி",
    "desc_ta": "ஊட்டச்சத்து நிறைந்த பச்சைப் பயறு பெசரட்டு மற்றும் இனிப்பு, புளிப்பு, காரம் நிறைந்த பாரம்பரிய இஞ்சி சட்னி.",
    "state_ta": "ஆந்திர பிரதேசம்",
    "cuisine_ta": "ஆந்திரா காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "மொறுமொறு பச்சைப் பயறு பெசரட்டு",
        "ingredients_ta": [
          [
            "பச்சைப் பயறு",
            "2 கப் ஊறவைத்தது"
          ],
          [
            "பச்சை மிளகாய் & இஞ்சி",
            "3 & 1 துண்டு"
          ],
          [
            "பொடியாக நறுக்கிய வெங்காயம் & சீரகம்",
            "மேலே தூவ"
          ],
          [
            "நல்லெண்ணெய் / நெய்",
            "2 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "பயறை இஞ்சி, பச்சை மிளகாய் சேர்த்து தோசை மாவு பதத்தில் அரைக்கவும்|தோசைக் கல்லில் மெல்லியதாக ஊற்றி மேலே வெங்காயம், சீரகம் தூவவும்|இருபுறமும் மொறுமொறுவென சுட்டு எடுக்கவும்"
      },
      {
        "name_ta": "ஆந்திரா அல்லம் (இஞ்சி) சட்னி",
        "ingredients_ta": [
          [
            "இஞ்சி",
            "1/2 கப்"
          ],
          [
            "புளி",
            "3 மேஜைக்கரண்டி"
          ],
          [
            "வெல்லம்",
            "3 மேஜைக்கரண்டி"
          ],
          [
            "காய்ந்த மிளகாய்",
            "4"
          ],
          [
            "உளுந்து & கடலைப்பருப்பு",
            "தலா 1 மேஜைக்கரண்டி"
          ],
          [
            "உப்பு",
            "1/2 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "பருப்புகள், மிளகாய், இஞ்சியை வதக்கி புளி, வெல்லம், உப்பு சேர்த்து கெட்டியாக அரைக்கவும்|கடுகு தாளிக்கவும்"
      }
    ]
  },
  "7": {
    "meal_ta": "ரவா உப்புமா + தேங்காய் சட்னி",
    "desc_ta": "நெய் மணக்கும் உதிரி உதிரியான ரவா உப்புமா மற்றும் காரசாரமான தேங்காய் சட்னி.",
    "state_ta": "கர்நாடகா",
    "cuisine_ta": "கர்நாடகா டிபன்",
    "dishes_ta": [
      {
        "name_ta": "காய்கறி ரவா உப்புமா",
        "ingredients_ta": [
          [
            "Roasted Rava (Sooji)",
            "1 cup"
          ],
          [
            "தண்ணீர்",
            "2.5 cups"
          ],
          [
            "வெங்காயம்",
            "1 cup chopped"
          ],
          [
            "இஞ்சி",
            "1 tsp each minced"
          ],
          [
            "கடுகு",
            "10 pcs & 1 tsp"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "handful"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "ரவையை நெய்யில் பொன்னிறமாக வறுத்து தனியாக வைக்கவும்|கடாயில் கடுகு, முந்திரி, பருப்பு, இஞ்சி, மிளகாய், வெங்காயம், காய்கறிகள் வதக்கவும்|தண்ணீர், உப்பு சேர்த்து கொதிக்கவிடவும்|வறுத்த ரவையை மெதுவாக தூவி கட்டியில்லாமல் கிளறி மூடி வைத்து 3 நிமிடம் வேகவைக்கவும்"
      }
    ]
  },
  "8": {
    "meal_ta": "ஆலூ பராத்தா + கெட்டித் தயிர் + வெண்ணெய்",
    "desc_ta": "மசாலா உருளைக்கிழங்கு பூரணம் வைத்து சுடச்சுட சுட்ட பஞ்சாபி பராத்தா மற்றும் குளிர்ந்த கெட்டித் தயிர்.",
    "state_ta": "பஞ்சாப்",
    "cuisine_ta": "பஞ்சாபி காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "பஞ்சாபி ஆலூ பராத்தா",
        "ingredients_ta": [
          [
            "கோதுமை மாவு",
            "2 கப்"
          ],
          [
            "மசித்த உருளைக்கிழங்கு",
            "2 கப்"
          ],
          [
            "சீரகத்தூள், மிளகாய்த்தூள், கரம் மசாலா",
            "தலா 1/2 தேக்கரண்டி"
          ],
          [
            "கொத்தமல்லி & பச்சை மிளகாய்",
            "பொடியாக நறுக்கியது"
          ],
          [
            "வெண்ணெய் / நெய்",
            "சுட"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்குடன் மசாலா பொடிகள், கொத்தமல்லி, உப்பு சேர்த்து மசாலா உருண்டைகள் செய்யவும்|கோதுமை மாவை பரப்பி நடுவில் மசாலா வைத்து மூடி மெதுவாக தேய்க்கவும்|தோசைக் கல்லில் இருபுறமும் வெண்ணெய் தடவி பொன்னிறமாக சுடவும்"
      },
      {
        "name_ta": "கெட்டித் தயிர் & ஊறுகாய்",
        "ingredients_ta": [
          [
            "கெட்டித் தயிர்",
            "1 கப்"
          ],
          [
            "மாங்காய் ஊறுகாய்",
            "1 மேஜைக்கரண்டி"
          ]
        ],
        "quick_ta": "சுடச்சுட பராத்தாவுடன் குளிர்ந்த தயிர் மற்றும் கார ஊறுகாய் பரிமாறவும்"
      }
    ]
  },
  "9": {
    "meal_ta": "கந்தா போஹா + மொறுமொறு சேவ் + எலுமிச்சை",
    "desc_ta": "வெங்காயம், வறுத்த வேர்க்கடலை மற்றும் மஞ்சள் தூள் சேர்த்து தாளித்த பஞ்சு போன்ற அவல் உப்மா.",
    "state_ta": "மகாராஷ்டிரா",
    "cuisine_ta": "மகாராஷ்டிரா காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "மகாராஷ்டிரா கந்தா போஹா",
        "ingredients_ta": [
          [
            "கெட்டி அவல்",
            "2 கப் கழுவி வடித்தது"
          ],
          [
            "வெங்காயம்",
            "1 பெரியது"
          ],
          [
            "வேர்க்கடலை",
            "3 மேஜைக்கரண்டி"
          ],
          [
            "பச்சை மிளகாய், கடுகு, கறிவேப்பிலை",
            "தாளிக்க"
          ],
          [
            "மஞ்சள் தூள்",
            "1/2 தேக்கரண்டி"
          ],
          [
            "எலுமிச்சை சாறு & கொத்தமல்லி",
            "தூவ"
          ],
          [
            "உப்பு",
            "1 தேக்கரண்டி"
          ]
        ],
        "quick_ta": "எண்ணெயில் வேர்க்கடலை வறுத்து கடுகு, கறிவேப்பிலை, பச்சை மிளகாய், வெங்காயம் வதக்கவும்|மஞ்சள் தூள், உப்பு மற்றும் நனைத்த அவல் சேர்த்து மெதுவாக கிளறவும்|எலுமிச்சை சாறு, கொத்தமல்லி, சேவ் தூவி பரிமாறவும்"
      }
    ]
  },
  "10": {
    "meal_ta": "கதம்ப சாம்பார் சாதம் + வறுத்த உருளைக்கிழங்கு + அப்பளம்",
    "desc_ta": "நெய் மணக்கும் பருப்பு காய்கறி சாம்பார் சாதம் மற்றும் காரசாரமான மொறுமொறு உருளைக்கிழங்கு வறுவல்.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "தமிழ்நாடு ஸ்பெஷல்",
    "dishes_ta": [
      {
        "name_ta": "சுடச்சுட சாம்பார் சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1 cup"
          ],
          [
            "துவரம் பருப்பு",
            "1/2 cup"
          ],
          [
            "கலவை காய்கறிகள்",
            "1.5 cups"
          ],
          [
            "புளிக்கரைசல்",
            "3 tbsp"
          ],
          [
            "சாம்பார் பொடி",
            "2 tbsp"
          ],
          [
            "பெருங்காயம்",
            "1/4 tsp each"
          ],
          [
            "நெய்",
            "3 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "தண்ணீர்",
            "4.5 cups"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "அரிசி, பருப்பு, காய்கறிகள், புளி, சாம்பார் பொடி, உப்பு சேர்த்து 4 விசில் விட்டு வேகவைக்கவும்|லேசாக கரண்டியால் மசித்துக்கொள்ளவும்|சூடான நெய்யில் கடுகு, முந்திரி, பெருங்காயம், கறிவேப்பிலை தாளித்துக் கொட்டி கலக்கவும்"
      },
      {
        "name_ta": "காரசார உருளைக்கிழங்கு வறுவல்",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 large"
          ],
          [
            "சாம்பார் பொடி",
            "1 tsp each"
          ],
          [
            "கறிவேப்பிலை",
            "1/2 tsp & 1 sprig"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கை மிளகாய் தூள், சாம்பார் பொடி, உப்பு சேர்த்து பிசறவும்|சூடான எண்ணெயில் கடுகு, கறிவேப்பிலை தாளித்து உருளை துண்டுகளை குறைந்த தீயில் மொறுமொறுவென வறுக்கவும்"
      },
      {
        "name_ta": "மொறுமொறு பொரித்த அப்பளம்",
        "ingredients_ta": [
          [
            "உளுத்தம் பருப்பு",
            "4 pcs"
          ],
          [
            "எண்ணெய்",
            "1 cup"
          ]
        ],
        "quick_ta": "சூடான எண்ணெயில் அப்பளத்தை 5 விநாடிகள் பொரித்து எடுக்கவும்"
      }
    ]
  },
  "11": {
    "meal_ta": "பூண்டு மிளகு ரசம் சாதம் + உருளைக்கிழங்கு வறுவல் + அப்பளம்",
    "desc_ta": "நாக்கிற்கு இதமான செரிமானத்திற்கு உகந்த காரசார பூண்டு மிளகு ரசம் மற்றும் வறுத்த உருளைக்கிழங்கு.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "தமிழ்நாடு ஸ்பெஷல்",
    "dishes_ta": [
      {
        "name_ta": "நாட்டு தக்காளி மிளகு ரசம்",
        "ingredients_ta": [
          [
            "தக்காளி",
            "2 mashed"
          ],
          [
            "புளிக்கரைசல்",
            "2 tbsp"
          ],
          [
            "சீரகம்",
            "1 tbsp each crushed"
          ],
          [
            "பூண்டு",
            "6 cloves crushed"
          ],
          [
            "பெருங்காயம்",
            "1/4 tsp each"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "நெய்",
            "1 tbsp"
          ],
          [
            "தண்ணீர்",
            "2.5 cups"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "புளித் தண்ணீரில் தக்காளி, மஞ்சள், பெருங்காயம், உப்பு சேர்த்து 5 நிமிடம் கொதிக்கவிடவும்|இடித்த பூண்டு, மிளகு, சீரகம் சேர்த்து நுரை கட்டி வரும் வரை மிதமான தீயில் வைக்கவும்|நெய்யில் கடுகு, கறிவேப்பிலை தாளித்து கொத்தமல்லி தூவி இறக்கவும்"
      },
      {
        "name_ta": "மொறுமொறு உருளைக்கிழங்கு ஃப்ரை",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 sliced"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கு வில்லைகளை எண்ணெயில் மிளகாய் தூள், உப்பு சேர்த்து பொன்னிறமாக மொறுமொறுவென வறுக்கவும்"
      },
      {
        "name_ta": "சுடு சோறு & அப்பளம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "அப்பளம்",
            "4 pcs"
          ],
          [
            "தண்ணீர்",
            "for cooking & frying"
          ]
        ],
        "quick_ta": "சாதத்தை உதிரியாக வடித்து மொறுமொறு அப்பளத்துடன் பரிமாறவும்"
      }
    ]
  },
  "12": {
    "meal_ta": "தயிர் சாதம் + உருளைக்கிழங்கு வறுவல் + மாங்காய் ஊறுகாய்",
    "desc_ta": "பால் மற்றும் தயிரில் குழைந்த க்ரீமியான தயிர் சாதம் மற்றும் காரசாரமான தொடுகறி.",
    "state_ta": "தமிழ்நாடு / தென்னிந்தியா",
    "cuisine_ta": "தமிழ்நாடு ஸ்பெஷல்",
    "dishes_ta": [
      {
        "name_ta": "கோவில் பாணி தாளித்த தயிர் சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தயிர்",
            "1 cup"
          ],
          [
            "பால்",
            "1/2 cup"
          ],
          [
            "வெண்ணெய்",
            "1 tbsp"
          ],
          [
            "இஞ்சி",
            "1 tsp each minced"
          ],
          [
            "உளுத்தம் பருப்பு",
            "1/2 tsp each"
          ],
          [
            "பெருங்காயம்",
            "1 pinch"
          ],
          [
            "கறிவேப்பிலை",
            "handful"
          ],
          [
            "நெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "சூடான சாதத்தை வெண்ணெய் மற்றும் பால் சேர்த்து மிருதுவாக மசிக்கவும்|தாளித்த கெட்டி தயிர், உப்பு சேர்த்து கலக்கவும்|கடுகு, இஞ்சி, பச்சை மிளகாய், கறிவேப்பிலை, மாதுளை சேர்த்து தாளிக்கவும்"
      },
      {
        "name_ta": "மொறுமொறு உருளைக்கிழங்கு ஃப்ரை",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 sliced"
          ],
          [
            "சாம்பார் பொடி",
            "1 tsp each"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கை மசாலா சேர்த்து மிதமான தீயில் மொறுமொறுவென பொன்னிறமாக வறுக்கவும்"
      }
    ]
  },
  "13": {
    "meal_ta": "கொங்கு அரிசி பருப்பு சாதம் + உருளைக்கிழங்கு வறுவல்",
    "desc_ta": "கொங்கு மண்டலத்தின் தனித்துவமான சுவையான ஒரு பானை பருப்பு சாதம் மற்றும் நெய்.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "கொங்குநாடு பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "கொங்குநாடு பாரம்பரிய அரிசி பருப்பு சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1 cup"
          ],
          [
            "துவரம் பருப்பு",
            "1/3 cup"
          ],
          [
            "சின்ன வெங்காயம்",
            "12 sliced"
          ],
          [
            "பூண்டு",
            "6 cloves"
          ],
          [
            "தக்காளி",
            "1 chopped"
          ],
          [
            "சாம்பார் பொடி",
            "1 tsp"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "தண்ணீர்",
            "3 cups"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "குக்கரில் நெய் சூடாக்கி கடுகு, சீரகம், கறிவேப்பிலை, காய்ந்த மிளகாய் தாளிக்கவும்|வெங்காயம், பூண்டு, தக்காளி, மஞ்சள் சேர்த்து வதக்கவும்|அரிசி, பருப்பு, தண்ணீர், உப்பு சேர்த்து 3 விசில் விட்டு வேகவைத்து நெய் ஊற்றி பரிமாறவும்"
      },
      {
        "name_ta": "மொறுமொறு உருளைக்கிழங்கு ஃப்ரை",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 cubed"
          ],
          [
            "Chilli Powder",
            "1 tsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கை மசாலா சேர்த்து மிதமான தீயில் பொன்னிறமாக வறுக்கவும்"
      }
    ]
  },
  "14": {
    "meal_ta": "திருநெல்வேலி சொதி + சுடுசாதம் + இஞ்சி பச்சடி",
    "desc_ta": "திருநெல்வேலி கல்யாண ஸ்பெஷல் காய்கறி தேங்காய்ப்பால் குழம்பு (சொதி) மற்றும் சாதம்.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "திருநெல்வேலி பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "திருநெல்வேலி பாரம்பரிய சொதி குழம்பு",
        "ingredients_ta": [
          [
            "பாசிப்பருப்பு",
            "1/2 cup"
          ],
          [
            "தேங்காய்ப்பால்",
            "1 cup & 2 cups"
          ],
          [
            "உருளைக்கிழங்கு",
            "1.5 cups"
          ],
          [
            "சின்ன வெங்காயம்",
            "10 sliced & 4 slit"
          ],
          [
            "இஞ்சி",
            "1 tbsp & 1.5 tbsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "காய்கறிகளை இரண்டாம் தேங்காய்ப்பாலில் இஞ்சி, பச்சை மிளகாய் சேர்த்து வேகவைக்கவும்|வேகவைத்த பாசிப்பருப்பு விழுது சேர்க்கவும்|முதல் கெட்டி தேங்காய்ப்பால் ஊற்றி ஒரு கொதி வந்ததும் இறக்கி எலுமிச்சை சாறு சேர்க்கவும்"
      },
      {
        "name_ta": "நெல்லை இஞ்சி புளி பச்சடி",
        "ingredients_ta": [
          [
            "இஞ்சி",
            "1/2 cup"
          ],
          [
            "Tamarind Extract",
            "1/2 cup"
          ],
          [
            "Jaggery",
            "2 tbsp"
          ],
          [
            "Chilli Powder & Turmeric",
            "1 tsp & 1/4 tsp"
          ],
          [
            "எண்ணெய்",
            "for tadka"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "நறுக்கிய இஞ்சியை நல்லெண்ணெயில் வதக்கவும்|புளிக்கரைசல், மிளகாய் தூள், வெல்லம் சேர்த்து கெட்டியாகும் வரை கொதிக்கவைத்து தாளிக்கவும்"
      },
      {
        "name_ta": "உருளை வறுவல் & சுடு சோறு",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 cubed"
          ],
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "சாம்பார் பொடி",
            "for cooking"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கை மசாலா சேர்த்து மொறுமொறுவென வறுத்து சுடச்சுட சாதத்துடன் பரிமாறவும்"
      }
    ]
  },
  "15": {
    "meal_ta": "செட்டிநாடு மிளகு சிக்கன் + ரசம் சாதம் + உருளைக்கிழங்கு வறுவல்",
    "desc_ta": "செட்டிநாடு வறுத்த மசாலா மற்றும் கருப்பு மிளகு மணக்கும் காரசாரமான சிக்கன் வறுவல்.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "செட்டிநாடு அசைவம்",
    "dishes_ta": [
      {
        "name_ta": "செட்டிநாடு மிளகு சிக்கன் சுக்கா",
        "ingredients_ta": [
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "500g"
          ],
          [
            "சின்ன வெங்காயம்",
            "15 sliced"
          ],
          [
            "மிளகு",
            "1.5 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1 tbsp"
          ],
          [
            "Cumin & Fennel Seeds",
            "1 tsp each"
          ],
          [
            "காய்ந்த மிளகாய்",
            "4 pcs"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "3 sprigs"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "மிளகு, தனியா, சோம்பு, சீரகம், காய்ந்த மிளகாய் வறுத்து பொடி செய்யவும்|நல்லெண்ணெயில் வெங்காயம், இஞ்சி-பூண்டு, சிக்கன் சேர்த்து வதக்கவும்|அரைத்த செட்டிநாடு மசாலா, உப்பு சேர்த்து சுருள வதக்கி இறக்கவும்"
      },
      {
        "name_ta": "பூண்டு மிளகு ரசம்",
        "ingredients_ta": [
          [
            "பூண்டு",
            "8 cloves"
          ],
          [
            "மிளகு",
            "1 tbsp each crushed"
          ],
          [
            "தக்காளி",
            "1 mashed"
          ],
          [
            "தண்ணீர்",
            "1.5 cups"
          ],
          [
            "பெருங்காயம்",
            "1/4 tsp each"
          ],
          [
            "நெய்",
            "1 tsp"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "புளித் தண்ணீரில் தக்காளி, மஞ்சள், உப்பு, பெருங்காயம் சேர்த்து கொதிக்கவிடவும்|இடித்த பூண்டு-மிளகு சேர்த்து நுரைத்து வரும்போது தாளித்து இறக்கவும்"
      },
      {
        "name_ta": "கார உருளைக்கிழங்கு வறுவல்",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 cubed"
          ],
          [
            "சாம்பார் பொடி",
            "1 tsp each"
          ],
          [
            "கறிவேப்பிலை",
            "1/2 tsp & 1 sprig"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "உருளைக்கிழங்கை மசாலா சேர்த்து குறைந்த தீயில் மொறுமொறுவென வறுக்கவும்"
      },
      {
        "name_ta": "சுடு சோறு",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தண்ணீர்",
            "3.5 cups"
          ]
        ],
        "quick_ta": "சுடு சோற்றை உதிரியாக வடித்து வைக்கவும்"
      }
    ]
  },
  "16": {
    "meal_ta": "திண்டுக்கல் தலப்பாகட்டி சிக்கன் பிரியாணி + தயிர் பச்சடி + கத்திரிக்காய் தால்ச்சா",
    "desc_ta": "சீரக சம்பா அரிசியில் நெய், இஞ்சி, பூண்டு, நறுமண மசாலாக்களுடன் தயாரான பாரம்பரிய பிரியாணி.",
    "state_ta": "தமிழ்நாடு / தெலங்கானா",
    "cuisine_ta": "ராயல் பிரியாணி",
    "dishes_ta": [
      {
        "name_ta": "மணமணக்கும் தம் சிக்கன் பிரியாணி",
        "ingredients_ta": [
          [
            "அரிசி",
            "2 cups"
          ],
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "600g"
          ],
          [
            "வெங்காயம்",
            "3 large"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "பச்சை மிளகாய்",
            "5 pcs"
          ],
          [
            "தயிர்",
            "1/2 cup"
          ],
          [
            "Biryani Garam Masala",
            "1.5 tsp"
          ],
          [
            "மஞ்சள் தூள்",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "கொத்தமல்லி",
            "1 cup chopped"
          ],
          [
            "நெய்",
            "3 tbsp each"
          ],
          [
            "உப்பு",
            "2 tsp"
          ]
        ],
        "quick_ta": "சிக்கனை தயிர், இஞ்சி பூண்டு, பிரியாணி மசாலா, புதினா, வறுத்த வெங்காயம் சேர்த்து ஊறவைக்கவும்|பாஸ்மதி அரிசியை முக்கால் பதம் வேகவைத்து வடிக்கவும்|பாத்திரத்தில் சிக்கன் மசாலா மீது சாதம், குங்குமப்பூ பால் சேர்த்து மூடி 20 நிமிடம் மிதமான தீயில் தம் போடவும்"
      },
      {
        "name_ta": "எண்ணெய் கத்திரிக்காய் கிரேவி",
        "ingredients_ta": [
          [
            "Small Brinjals",
            "4 slit"
          ],
          [
            "Peanuts & Sesame Seeds",
            "2 tbsp each roasted & ground"
          ],
          [
            "புளிக்கரைசல்",
            "2 tbsp"
          ],
          [
            "வெங்காயம்",
            "1 chopped"
          ],
          [
            "சாம்பார் பொடி",
            "1.5 tsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "கத்திரிக்காயை எண்ணெயில் வதக்கவும்|வேர்க்கடலை, எள், தேங்காய் மசாலா வதக்கி புளி சேர்த்து எண்ணெய் பிரியும் வரை கொதிக்கவிடவும்"
      },
      {
        "name_ta": "குளிர்ந்த வெங்காய தயிர் பச்சடி",
        "ingredients_ta": [
          [
            "தயிர்",
            "1 cup"
          ],
          [
            "வெங்காயம்",
            "1 finely sliced"
          ],
          [
            "கொத்தமல்லி",
            "1 tsp each"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "கெட்டி தயிரில் பொடியாக நறுக்கிய வெங்காயம், பச்சை மிளகாய், கொத்தமல்லி, உப்பு சேர்த்து கலக்கவும்"
      }
    ]
  },
  "17": {
    "meal_ta": "கிராமத்து மண் சட்டி மீன் குழம்பு + சுடுசாதம் + மொறுமொறு மீன் வறுவல்",
    "desc_ta": "சின்ன வெங்காயம், பூண்டு, தக்காளி மற்றும் புளித்தண்ணீரில் கொதித்து அடுத்த நாள் சாப்பிட்டால் இன்னும் சுவை கூடும் மீன் குழம்பு.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "கடலோர மீன் உணவு",
    "dishes_ta": [
      {
        "name_ta": "மதராஸ் கிராமத்து மீன் குழம்பு",
        "ingredients_ta": [
          [
            "மீன்",
            "500g"
          ],
          [
            "சின்ன வெங்காயம்",
            "15 peeled"
          ],
          [
            "பூண்டு",
            "10 cloves"
          ],
          [
            "தக்காளி",
            "2 pureed"
          ],
          [
            "புளிக்கரைசல்",
            "4 tbsp"
          ],
          [
            "சாம்பார் பொடி",
            "2.5 tbsp"
          ],
          [
            "வெந்தயம்",
            "1/4 tsp & 1/2 tsp"
          ],
          [
            "கறிவேப்பிலை",
            "for tempering"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "மண்பானையில் நல்லெண்ணெய் ஊற்றி கடுகு, வெந்தயம், கறிவேப்பிலை தாளிக்கவும்|பூண்டு, சின்ன வெங்காயம், தக்காளி வதக்கி மிளகாய் தூள், மல்லி தூள் சேர்க்கவும்|புளிக்கரைசல் ஊற்றி கொதித்ததும் மீன் துண்டுகளை சேர்த்து 7 நிமிடம் வேகவைத்து இறக்கவும்"
      },
      {
        "name_ta": "மசாலா மீன் வறுவல்",
        "ingredients_ta": [
          [
            "மீன்",
            "300g"
          ],
          [
            "Chilli Powder",
            "1.5 tsp"
          ],
          [
            "Turmeric & Pepper Powder",
            "1/2 tsp each"
          ],
          [
            "பூண்டு",
            "1 tbsp & 1 tsp"
          ],
          [
            "அரிசி",
            "1 tbsp"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "மிளகாய் தூள், மஞ்சள் தூள், மிளகு தூள், இஞ்சி பூண்டு, எலுமிச்சை சாறு சேர்த்து மீனில் தடவி 20 நிமிடம் ஊறவைக்கவும்|தோசைக் கல்லில் எண்ணெய் விட்டு இருபுறமும் பொன்னிறமாக வறுக்கவும்"
      },
      {
        "name_ta": "சுடு சோறு",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தண்ணீர்",
            "3.5 cups"
          ]
        ],
        "quick_ta": "சாதத்தை மிருதுவாக வேகவைத்து பரிமாறவும்"
      }
    ]
  },
  "18": {
    "meal_ta": "தால் தட்கா + சீரக சாதம் + ஆலூ கோபி",
    "desc_ta": "நெய் மற்றும் சீரகத்தில் தாளித்த தால் தட்கா, வாசனை சீரக சாதம் மற்றும் உருளைக்கிழங்கு காலிஃபிளவர் மசாலா.",
    "state_ta": "டெல்லி / பஞ்சாப்",
    "cuisine_ta": "வட இந்திய தாபா உணவு",
    "dishes_ta": [
      {
        "name_ta": "தால் தட்கா பருப்பு",
        "ingredients_ta": [
          [
            "துவரம் பருப்பு",
            "1 cup boiled with turmeric"
          ],
          [
            "பூண்டு",
            "8 cloves"
          ],
          [
            "தக்காளி",
            "1 each chopped"
          ],
          [
            "நெய்",
            "2.5 tbsp"
          ],
          [
            "சீரகம்",
            "1 tsp & 1/4 tsp"
          ],
          [
            "காய்ந்த மிளகாய்",
            "2 pcs & 1 tsp"
          ],
          [
            "கொத்தமல்லி",
            "1 tsp & handful"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "துவரம் பருப்பை மஞ்சள் சேர்த்து வேகவைக்கவும்|நெய்யில் வெங்காயம், தக்காளி, இஞ்சி பூண்டு வதக்கி பருப்பில் சேர்க்கவும்|இரண்டாவது தாளிப்பாக பூண்டு, சீரகம், காய்ந்த மிளகாய், மிளகாய் தூள் பொரித்து பருப்பில் ஊற்றி கொத்தமல்லி தூவவும்"
      },
      {
        "name_ta": "ஆலு கோபி சப்ஜி",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "1.5 cups each cubed & florets"
          ],
          [
            "இஞ்சி",
            "1 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1/2 tsp, 1 tsp & 1/2 tsp"
          ],
          [
            "சீரகம்",
            "1 tsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "கடாயில் எண்ணெய் சூடாக்கி சீரகம், இஞ்சி தாளிக்கவும்|உருளை, காலிஃபிளவர், மஞ்சள், உப்பு சேர்த்து 3 நிமிடம் வதக்கவும்|தண்ணீர் சேர்க்காமல் மூடி மிதமான தீயில் 10 நிமிடம் வேகவிடவும்|மல்லித்தூள், கரம் மசாலா சேர்த்து பொன்னிறமாக வதக்கவும்"
      },
      {
        "name_ta": "சீரக சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "சீரகம்",
            "1.5 tbsp"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "பாஸ்மதி சாதத்தை வடித்து, நெய்யில் பொரித்த சீரகத்தை சேர்த்து மெதுவாக கிளறவும்"
      }
    ]
  },
  "19": {
    "meal_ta": "பஞ்சாபி ராஜ்மா சாவல் + சாலட்",
    "desc_ta": "பஞ்சாபி ஸ்டைல் வெண்ணெய் மற்றும் மசாலா மணக்கும் சிவப்பு காராமணி கிரேவி மற்றும் பாசுமதி சாதம்.",
    "state_ta": "பஞ்சாப்",
    "cuisine_ta": "பஞ்சாபி பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "பஞ்சாபி மசாலா ராஜ்மா",
        "ingredients_ta": [
          [
            "Red Kidney Beans (Rajma soaked overnight)",
            "1.5 cups"
          ],
          [
            "வெங்காயம்",
            "2 large"
          ],
          [
            "தக்காளி",
            "2 cups"
          ],
          [
            "பூண்டு",
            "1.5 tbsp"
          ],
          [
            "Rajma Masala / Garam Masala",
            "1.5 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1 tbsp each"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "கஸ்தூரி மேத்தி",
            "1 tsp"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "ஊறவைத்த ராஜ்மாவை உப்பு சேர்த்து குக்கரில் 6 விசில் வரை மென்மையாக வேகவைக்கவும்|நெய்யில் வெங்காயம், இஞ்சி பூண்டு, தக்காளி விழுது மசாலாக்களுடன் வதக்கவும்|வெந்த ராஜ்மாவை சேர்த்து 15 நிமிடம் கொதிக்கவிடவும்|வெண்ணெய் மற்றும் கசூரி மேத்தி தூவி இறக்கவும்"
      },
      {
        "name_ta": "பாஸ்மதி சாதம் & சாலட்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தக்காளி",
            "1 cup"
          ],
          [
            "Lemon Juice & Chaat Masala",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_ta": "பாஸ்மதி சாதத்தை பொலபொலவென வடிக்கவும்|காய்கறிகளை நறுக்கி எலுமிச்சை சாறு, சாட் மசாலா சேர்த்து கலக்கவும்"
      }
    ]
  },
  "20": {
    "meal_ta": "ஆந்திரா காரசார சிக்கன் கறி + சுடுசாதம்",
    "desc_ta": "குண்டூர் காய்ந்த மிளகாய் மசாலா சேர்த்து சமைத்த காரசாரமான ஆந்திரா நாட்டுக் கோழி வறுவல்.",
    "state_ta": "ஆந்திர பிரதேசம்",
    "cuisine_ta": "ஆந்திரா கார உணவு",
    "dishes_ta": [
      {
        "name_ta": "குண்டூர் கார சிக்கன் கறி",
        "ingredients_ta": [
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "600g"
          ],
          [
            "வெங்காயம்",
            "2 large"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "Guntur Red Chilli Powder",
            "2 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1.5 tbsp & 1 tsp ground"
          ],
          [
            "துருவிய தேங்காய்",
            "1 tbsp each ground to paste"
          ],
          [
            "Garam Masala",
            "1 tsp"
          ],
          [
            "கறிவேப்பிலை",
            "3 sprigs"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "எண்ணெயில் வெங்காயம், கறிவேப்பிலை, இஞ்சி பூண்டு வதக்கி சிக்கன் சேர்க்கவும்|மஞ்சள், குண்டூர் மிளகாய் தூள், மல்லித்தூள் சேர்த்து 5 நிமிடம் வதக்கவும்|அரைத்த தேங்காய் கசகசா விழுது, 1.5 கப் தண்ணீர் ஊற்றி எண்ணெய் பிரியும் வரை 15 நிமிடம் கொதிக்கவிடவும்|கரம் மசாலா, கொத்தமல்லி தூவவும்"
      },
      {
        "name_ta": "சுடு சோறு & சுத்தமான நெய்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "நெய்",
            "1 tbsp"
          ]
        ],
        "quick_ta": "சாதத்தை சூடாக வடித்து மேலே சுத்தமான நெய் ஊற்றி பரிமாறவும்"
      }
    ]
  },
  "21": {
    "meal_ta": "சாஃப்ட் சப்பாத்தி + பன்னீர் பட்டர் மசாலா",
    "desc_ta": "பஞ்சு போன்ற மெதுவான கோதுமை சப்பாத்தி மற்றும் க்ரீமியான சுவையான பன்னீர் வெண்ணெய் கிரேவி.",
    "state_ta": "வட இந்தியா",
    "cuisine_ta": "வட இந்திய வீட்டு உணவு",
    "dishes_ta": [
      {
        "name_ta": "மெதுவான புல்கா சப்பாத்தி",
        "ingredients_ta": [
          [
            "கோதுமை மாவு",
            "2 cups"
          ],
          [
            "தண்ணீர்",
            "3/4 cup"
          ],
          [
            "நெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "கோதுமை மாவில் உப்பு, தண்ணீர் சேர்த்து மென்மையாக பிசைந்து 15 நிமிடம் ஊறவைக்கவும்|மெல்லிய வட்டங்களாக தேய்த்து சூடான தவாவில் இட்டு நேரடியாக தீயில் காட்டி உப்ப வைத்து எடுக்கவும்"
      },
      {
        "name_ta": "பன்னீர் பட்டர் மசாலா",
        "ingredients_ta": [
          [
            "பன்னீர்",
            "250g"
          ],
          [
            "தக்காளி",
            "2 cups"
          ],
          [
            "வெங்காயம்",
            "1 finely chopped"
          ],
          [
            "முந்திரி விழுது",
            "10 cashews blended"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "வெண்ணெய்",
            "3 tbsp & 2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tsp"
          ],
          [
            "Garam Masala & Kasuri Methi",
            "1/2 tsp & 1 tsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "வெண்ணெயில் வெங்காயம், இஞ்சி பூண்டு வதக்கி தக்காளி விழுது, மிளகாய் தூள், கரம் மசாலா சேர்த்து வேகவைக்கவும்|கஸ்தூரி மேத்தி, பிரஷ் கிரீம், பன்னீர் துண்டுகள் சேர்த்து 5 நிமிடம் கொதிக்கவிடவும்"
      }
    ]
  },
  "22": {
    "meal_ta": "பட்டர் சிக்கன் + பூண்டு நான் + சீரக சாதம்",
    "desc_ta": "வெண்ணெய் மற்றும் க்ரீமில் ஊறிய பஞ்சாபி தந்தூரி பட்டர் சிக்கன் மற்றும் சுடச்சுட வெண்ணெய் நான்.",
    "state_ta": "டெல்லி / பஞ்சாப்",
    "cuisine_ta": "முகலாய் வட இந்திய உணவு",
    "dishes_ta": [
      {
        "name_ta": "பட்டர் சிக்கன் (முர்க் மக்கனி)",
        "ingredients_ta": [
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "500g"
          ],
          [
            "தயிர்",
            "1/2 cup"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "2 tbsp"
          ],
          [
            "தக்காளி",
            "2 cups"
          ],
          [
            "முந்திரி விழுது",
            "15 cashews blended"
          ],
          [
            "வெண்ணெய்",
            "4 tbsp"
          ],
          [
            "Fresh Cream",
            "3 tbsp"
          ],
          [
            "கஸ்தூரி மேத்தி",
            "1 tbsp"
          ],
          [
            "Garam Masala & Honey",
            "1 tsp each"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "சிக்கனை தயிர் மற்றும் மசாலாக்களில் ஊறவைத்து தவாவில் பொன்னிறமாக வறுக்கவும்|வெண்ணெயில் தக்காளி விழுது, காஷ்மீரி மிளகாய் தூள் 12 நிமிடம் வதக்கவும்|முந்திரி விழுது, க்ரீம், வறுத்த சிக்கன், தேன், கரம் மசாலா சேர்க்கவும்|6 நிமிடம் கொதிக்கவைத்து வெண்ணெய் மற்றும் கசூரி மேத்தி தூவவும்"
      },
      {
        "name_ta": "பூண்டு வெண்ணெய் நான்",
        "ingredients_ta": [
          [
            "Maida (Flour)",
            "2 cups"
          ],
          [
            "தயிர்",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "3 tbsp & 1 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "மாவை தயிர் சேர்த்து பிசைந்து 30 நிமிடம் ஊறவைக்கவும்|நீளவாக்கில் தேய்த்து பூண்டு, கொத்தமல்லி பதித்து சூடான இரும்பு தவாவில் சுட்டு தீயில் உப்ப வைக்கவும்|வெண்ணெய் தடவவும்"
      },
      {
        "name_ta": "சீரக சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "சீரகம்",
            "1.5 tbsp"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "பாஸ்மதி சாதத்தில் நெய்யில் வறுத்த சீரகத்தை சேர்த்து கிளறவும்"
      }
    ]
  },
  "23": {
    "meal_ta": "மலபார் பொரோட்டா + சிக்கன் சால்னா / வெஜ் குருமா",
    "desc_ta": "அடுக்கு அடுக்காக மெதுவான மலபார் பரோட்டா மற்றும் சுடச்சுட ஹோட்டல் சால்னா.",
    "state_ta": "தமிழ்நாடு / கேரளா",
    "cuisine_ta": "ரோட்டுக்கடை டிபன்",
    "dishes_ta": [
      {
        "name_ta": "அடுக்கு மலபார் பரோட்டா",
        "ingredients_ta": [
          [
            "Maida (Flour)",
            "2 cups"
          ],
          [
            "உப்பு",
            "1 tsp & 1/2 tsp"
          ],
          [
            "நெய்",
            "4 tbsp"
          ],
          [
            "தண்ணீர்",
            "3/4 cup"
          ]
        ],
        "quick_ta": "மாவை மென்மையாக பிசைந்து 1 மணி நேரம் ஊறவைக்கவும்|மெல்லியதாக விரித்து மடித்து சுருட்டி தவா வில் பொன்னிறமாக சுட்டெடுக்கவும்|சூடாக இருக்கும்போதே கைகளால் பக்கவாட்டில் தட்டி அடுக்குகளை பிரிக்கவும்"
      },
      {
        "name_ta": "மதுரை ரோட்டுக்கடை சிக்கன் சால்னா",
        "ingredients_ta": [
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "400g"
          ],
          [
            "தக்காளி",
            "1 cup & 2 chopped"
          ],
          [
            "துருவிய தேங்காய்",
            "1/2 cup, 6 pcs & 1 tbsp ground to fine paste"
          ],
          [
            "பூண்டு",
            "1.5 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1 tbsp each"
          ],
          [
            "கொத்தமல்லி",
            "handful"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "எண்ணெயில் சின்ன வெங்காயம், தக்காளி, இஞ்சி பூண்டு வதக்கி சிக்கன் மற்றும் மசாலா சேர்க்கவும்|தண்ணீர் ஊற்றி 12 நிமிடம் வேகவிடவும்|தேங்காய் முந்திரி சோம்பு விழுது ஊற்றி 6 நிமிடம் கொதிக்கவிடவும்|புதினா கொத்தமல்லி தூவவும்"
      }
    ]
  },
  "24": {
    "meal_ta": "சீஸ் மார்கரிட்டா பீட்சா + கார்லிக் பிரெட்",
    "desc_ta": "மொஸரெல்லா சீஸ் மற்றும் தக்காளி சாஸ் நிறைந்த சுடச்சுட பீட்சா மற்றும் பூண்டு ரொட்டி.",
    "state_ta": "இத்தாலி",
    "cuisine_ta": "இத்தாலியன் உணவு",
    "dishes_ta": [
      {
        "name_ta": "கிளாசிக் சீஸ் மார்கரிட்டா பீட்சா",
        "ingredients_ta": [
          [
            "Pizza Dough / Pizza Base",
            "1 base"
          ],
          [
            "தக்காளி",
            "1/2 cup"
          ],
          [
            "Mozzarella Cheese (shredded/fresh)",
            "1.5 cups"
          ],
          [
            "துளசி & ஓரிகானோ",
            "handful & 1 tsp"
          ],
          [
            "எண்ணெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "to taste"
          ]
        ],
        "quick_ta": "பீட்சா மாவை தட்டில் வட்டமாக பரப்பவும்|பீட்சா சாஸ் தடவி மொசரெல்லா சீஸ் தாராளமாக தூவவும்|அவனில் 240 டிகிரியில் 10-12 நிமிடம் பொன்னிறமாக பேக் செய்யவும்|துளசி இலைகள் மற்றும் ஆலிவ் ஆயில் தூவி பரிமாறவும்"
      },
      {
        "name_ta": "கார்லிக் பிரெட்",
        "ingredients_ta": [
          [
            "Bread / Baguette Slices",
            "4 pcs"
          ],
          [
            "வெண்ணெய்",
            "2 tbsp"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "ஓரிகானோ & பார்ஸ்லி",
            "1/2 tsp each"
          ],
          [
            "உப்பு",
            "pinch"
          ]
        ],
        "quick_ta": "வெண்ணெயில் பூண்டு, மூலிகைகள் கலக்கவும்|பிரெட் துண்டுகளில் தடவி தவா அல்லது அவனில் மொறுமொறுப்பாக டோஸ்ட் செய்யவும்"
      }
    ]
  },
  "25": {
    "meal_ta": "ஒயிட் சாஸ் பாஸ்தா (ஆல்ஃபிரடோ பாஸ்தா) + கார்லிக் டோஸ்ட்",
    "desc_ta": "க்ரீமியான சீஸ் மற்றும் பால் சாஸில் சமைத்த இத்தாலியன் பாஸ்தா.",
    "state_ta": "இத்தாலி",
    "cuisine_ta": "இத்தாலியன் பாஸ்தா",
    "dishes_ta": [
      {
        "name_ta": "கிரிமி ஒயிட் சாஸ் பாஸ்தா",
        "ingredients_ta": [
          [
            "Penne / Fettuccine Pasta",
            "200g boiled al dente"
          ],
          [
            "வெண்ணெய்",
            "2 tbsp"
          ],
          [
            "Maida (Flour)",
            "2 tbsp"
          ],
          [
            "பால்",
            "2 cups"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "Sweet Corn & Capsicum",
            "1/2 cup each sautéed"
          ],
          [
            "Cheese (Mozzarella / Parmesan)",
            "1/2 cup grated"
          ],
          [
            "மிளகு",
            "1 tsp each"
          ],
          [
            "உப்பு",
            "to taste"
          ]
        ],
        "quick_ta": "பாஸ்தாவை உப்பு நீரில் வேகவைத்து வடிகட்டவும்|வெண்ணெயில் பூண்டு வதக்கி மைதா சேர்த்து பால் ஊற்றி கட்டியில்லாமல் க்ரீமி சாஸ் தயாரிக்கவும்|சீஸ், காய்கறிகள், பாஸ்தா, மிளகுத்தூள், ஓரிகானோ சேர்த்து 2 நிமிடம் கொதிக்கவிடவும்"
      }
    ]
  },
  "26": {
    "meal_ta": "காய்கறி ஃப்ரைடு ரைஸ் + கோபி மஞ்சூரியன்",
    "desc_ta": "சீன ஸ்டைல் காய்கறி சாதம் மற்றும் மொறுமொறுப்பான காலிஃபிளவர் மஞ்சூரியன் கிரேவி.",
    "state_ta": "இண்டோ-சைனீஸ்",
    "cuisine_ta": "இண்டோ-சைனீஸ்",
    "dishes_ta": [
      {
        "name_ta": "காய்கறி வெஜ் ஃப்ரைட் ரைஸ்",
        "ingredients_ta": [
          [
            "அரிசி",
            "3 cups"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "Carrots, Beans, Cabbage, Capsicum",
            "1.5 cups finely chopped"
          ],
          [
            "வெங்காயம்",
            "1/2 cup"
          ],
          [
            "சோயா சாஸ்",
            "1.5 tbsp"
          ],
          [
            "மிளகு",
            "1 tsp & 1/2 tsp"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "சூடான கடாயில் பூண்டு, வெங்காயத்தாள் வதக்கி நறுக்கிய காய்கறிகளை அதிக தீயில் 2 நிமிடம் வதக்கவும்|வடித்த சாதம், சோயா சாஸ், வினிகர், மிளகுத்தூள் சேர்த்து அதிக தீயில் கிளறவும்|வெங்காயத்தாள் தூவவும்"
      },
      {
        "name_ta": "மொறுமொறு கோபி மஞ்சூரியன்",
        "ingredients_ta": [
          [
            "Cauliflower (Gobi florets)",
            "250g"
          ],
          [
            "Cornstarch & Maida",
            "3 tbsp each"
          ],
          [
            "பூண்டு",
            "1 tbsp each"
          ],
          [
            "தக்காளி",
            "1 tbsp each"
          ],
          [
            "வெங்காயம்",
            "1/4 cup"
          ],
          [
            "எண்ணெய்",
            "for cooking"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "காலிஃபிளவரை சோளமாவு கலவையில் முக்கி எண்ணெயில் பொரித்தெடுக்கவும்|பூண்டு, இஞ்சி, மிளகாய், வெங்காயம் வதக்கி சாஸ்கள் மற்றும் சோளமாவு கரைசல் சேர்த்து கொதிக்கவிடவும்|பரிமாறுவதற்கு முன் பொரித்த காலிஃபிளவரை சேர்த்து கிளறவும்"
      }
    ]
  },
  "27": {
    "meal_ta": "சில்லி சிக்கன் + வெஜ் ஹக்கா நூடுல்ஸ்",
    "desc_ta": "காரசாரமான சீன சில்லி சிக்கன் மற்றும் காய்கறி நூடுல்ஸ்.",
    "state_ta": "மேற்கு வங்காளம்",
    "cuisine_ta": "இண்டோ-சைனீஸ் அசைவம்",
    "dishes_ta": [
      {
        "name_ta": "கொல்கத்தா சில்லி சிக்கன்",
        "ingredients_ta": [
          [
            "கோழி இறைச்சி (சிக்கன்)",
            "400g"
          ],
          [
            "முட்டை",
            "2 tbsp & 1 egg white"
          ],
          [
            "Soy Sauce, Green Chilli Sauce, Vinegar",
            "1.5 tbsp each"
          ],
          [
            "வெங்காயம்",
            "1 cup each"
          ],
          [
            "பூண்டு",
            "1.5 tbsp each"
          ],
          [
            "பச்சை மிளகாய்",
            "4 pcs"
          ],
          [
            "வெங்காயம்",
            "1/2 cup"
          ],
          [
            "எண்ணெய்",
            "for cooking"
          ],
          [
            "மிளகு",
            "1/2 tsp each"
          ]
        ],
        "quick_ta": "சிக்கனை முட்டை வெள்ளைக்கரு, சோளமாவு, சோயா சாஸில் ஊறவைத்து பொரிக்கவும்|கடாயில் பூண்டு, இஞ்சி, பச்சை மிளகாய், வெங்காயம், குடைமிளகாய் வதக்கவும்|சோயா சாஸ், சில்லி சாஸ், வினிகர் சேர்த்து சாஸ் தயாரித்து பொரித்த சிக்கனை கிளறவும்"
      },
      {
        "name_ta": "வெஜ் ஹக்கா நூடுல்ஸ்",
        "ingredients_ta": [
          [
            "Hakka Noodles",
            "200g boiled al dente"
          ],
          [
            "Carrots, Cabbage, Capsicum (juliennes)",
            "1.5 cups"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "சோயா சாஸ் & வினிகர்",
            "1 tbsp each"
          ],
          [
            "மிளகு",
            "1 tbsp & 1/2 tsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "நூடுல்ஸை வேகவைத்து வடிகட்டவும்|காய்கறிகளை கடாயில் அதிக தீயில் வதக்கி நூடுல்ஸ் மற்றும் சாஸ்கள் சேர்த்து கிளறவும்"
      }
    ]
  },
  "28": {
    "meal_ta": "பாட் தாய் நூடுல்ஸ் + வறுத்த வேர்க்கடலை",
    "desc_ta": "தாய்லாந்து பாரம்பரிய புளிப்பு கார இனிப்பு நூடுல்ஸ் மற்றும் வேர்க்கடலை.",
    "state_ta": "தாய்லாந்து",
    "cuisine_ta": "தாய்லாந்து உணவு",
    "dishes_ta": [
      {
        "name_ta": "பாங்காக் பேட் தாய் நூடுல்ஸ்",
        "ingredients_ta": [
          [
            "அரிசி",
            "200g"
          ],
          [
            "டோஃபு (பன்னீர் கட்டிகள்)",
            "1/2 cup"
          ],
          [
            "Tamarind Paste & Brown Sugar",
            "2 tbsp each"
          ],
          [
            "சோயா சாஸ்",
            "2 tbsp"
          ],
          [
            "வெங்காயம்",
            "1 cup & 1/2 cup"
          ],
          [
            "Crushed Roasted Peanuts & Lime",
            "3 tbsp & wedges"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ]
        ],
        "quick_ta": "புளிச்சாறு, பழுப்பு சர்க்கரை, சோயா சாஸ் கலந்து சாஸ் தயாரிக்கவும்|கடாயில் டோஃபு பொன்னிறமாக வறுக்கவும்|ஊறவைத்த அரிசி நூடுல்ஸ் மற்றும் சாஸ் சேர்த்து அதிக தீயில் 2 நிமிடம் கிளறவும்|முளைகட்டிய பயறு, வேர்க்கடலை மற்றும் எலுமிச்சை சாறு சேர்த்து பரிமாறவும்"
      }
    ]
  },
  "29": {
    "meal_ta": "ஜப்பானிய ராமென் நூடுல்ஸ் சூப் கிண்ணம்",
    "desc_ta": "சூடான நறுமணமிக்க காய்கறி சூப்பில் நூடுல்ஸ் மற்றும் வேகவைத்த முட்டை.",
    "state_ta": "ஜப்பான்",
    "cuisine_ta": "ஜப்பானிய ரேமன்",
    "dishes_ta": [
      {
        "name_ta": "டோக்கியோ ஷோயு ரேமன் நூடுல்ஸ்",
        "ingredients_ta": [
          [
            "Ramen Noodles",
            "200g"
          ],
          [
            "காய்கறி வடிசாறு",
            "3 cups"
          ],
          [
            "எண்ணெய்",
            "3 tbsp & 1 tbsp"
          ],
          [
            "பூண்டு",
            "1 tsp each"
          ],
          [
            "முட்டை",
            "2 halves"
          ],
          [
            "மக்காச்சோளம், வெங்காயத்தாள்",
            "for topping"
          ],
          [
            "உப்பு",
            "pinch"
          ]
        ],
        "quick_ta": "சோயா சாஸ், நல்லெண்ணெய், இஞ்சி, பூண்டு சேர்த்து சூப் கொதிக்கவிடவும்|ரேமன் நூடுல்ஸை 2 நிமிடம் வேகவைத்து வடிகட்டவும்|கிண்ணத்தில் நூடுல்ஸ் வைத்து சூப் ஊற்றி முட்டை, சோளம், வெங்காயத்தாள் சேர்த்து பரிமாறவும்"
      }
    ]
  },
  "30": {
    "meal_ta": "ஃபலாஃபல் பிதா பாக்கெட் + க்ரீமி ஹம்மஸ்",
    "desc_ta": "மத்திய கிழக்கு கொண்டைக்கடலை ஃபலாஃபல் மற்றும் சுவையான ஹம்மஸ் துவையல்.",
    "state_ta": "லெபனான் / மத்திய கிழக்கு",
    "cuisine_ta": "மத்திய கிழக்கு உணவு",
    "dishes_ta": [
      {
        "name_ta": "லெபனான் ஃபலாஃபெல்",
        "ingredients_ta": [
          [
            "Chickpeas (soaked raw overnight)",
            "1.5 cups"
          ],
          [
            "கொத்தமல்லி",
            "1 cup chopped"
          ],
          [
            "வெங்காயம்",
            "4 cloves & 1 chopped"
          ],
          [
            "கொத்தமல்லி",
            "1 tsp each"
          ],
          [
            "Baking Powder",
            "1/2 tsp"
          ],
          [
            "எண்ணெய்",
            "2 cups"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "ஊறவைத்த கொண்டைக்கடலை, பூண்டு, கொத்தமல்லி, மசாலாக்களை கொரகொரப்பாக அரைக்கவும்|சிறு வடைகளாக தட்டி சூடான எண்ணெயில் பொன்னிறமாக பொரிக்கவும்"
      },
      {
        "name_ta": "ஹம்முஸ் & பீட்டா பிரெட்",
        "ingredients_ta": [
          [
            "எண்ணெய்",
            "1.5 cups"
          ],
          [
            "எள் விழுது (தஹினி)",
            "1/3 cup"
          ],
          [
            "Lemon Juice",
            "2 tbsp"
          ],
          [
            "பூண்டு",
            "1 clove"
          ],
          [
            "Pita Bread",
            "4 pcs"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "அவித்த கொண்டைக்கடலை, எலுமிச்சை சாறு, பூண்டு, ஆலிவ் எண்ணெய் நைசாக அரைத்து பீட்டா பிரெட்டுடன் பரிமாறவும்"
      }
    ]
  },
  "31": {
    "meal_ta": "மும்பை பாவ் பாஜி + வெண்ணெய் பாவ் ரொட்டி",
    "desc_ta": "வெண்ணெயில் வதங்கிய காய்கறி மசாலா பாஜி மற்றும் சூடான வெண்ணெய் பாவ்.",
    "state_ta": "மகாராஷ்டிரா",
    "cuisine_ta": "மும்பை ஸ்ட்ரீட் ஃபுட்",
    "dishes_ta": [
      {
        "name_ta": "மும்பை தவா பாவ் பாஜி",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "3 cups mashed"
          ],
          [
            "வெங்காயம்",
            "1 cup each finely chopped"
          ],
          [
            "தக்காளி",
            "4 finely chopped"
          ],
          [
            "பூண்டு",
            "2 tbsp"
          ],
          [
            "Pav Bhaji Masala",
            "2.5 tbsp"
          ],
          [
            "Kashmiri Chilli Powder",
            "1.5 tbsp"
          ],
          [
            "வெண்ணெய்",
            "75g"
          ],
          [
            "கொத்தமல்லி",
            "2 tbsp & 1/2 cup"
          ],
          [
            "கஸ்தூரி மேத்தி",
            "1 tsp"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "உருளை, காலிஃபிளவர், பட்டாணியை வேகவைத்து மசிக்கவும்|வெண்ணெயில் வெங்காயம், இஞ்சி பூண்டு, குடைமிளகாய், தக்காளி, பாவ் பாஜி மசாலா வதக்கவும்|மசித்த காய்கறிகள் சேர்த்து தவா வில் மசித்து கொதிக்கவிடவும்|வெண்ணெய், கசூரி மேத்தி, எலுமிச்சை சாறு சேர்க்கவும்"
      },
      {
        "name_ta": "பட்டர் பாவ் பிரெட்",
        "ingredients_ta": [
          [
            "Soft Pav Buns",
            "6 pcs"
          ],
          [
            "வெண்ணெய்",
            "3 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "pinch for dusting"
          ]
        ],
        "quick_ta": "பாவ் ரொட்டியை வெண்ணெயில் தவா வில் பொன்னிறமாக டோஸ்ட் செய்யவும்"
      }
    ]
  },
  "32": {
    "meal_ta": "டெல்லி சோலே பட்டூரே + ஊறுகாய்",
    "desc_ta": "உப்பிய பெரிய பட்டூரே மற்றும் காரசாரமான பஞ்சாபி கருப்பு கொண்டைக்கடலை சோலே.",
    "state_ta": "பஞ்சாப் / டெல்லி",
    "cuisine_ta": "பஞ்சாபி ஸ்ட்ரீட் ஃபுட்",
    "dishes_ta": [
      {
        "name_ta": "பஞ்சாபி பட்டூரா",
        "ingredients_ta": [
          [
            "Maida (Flour)",
            "2 cups"
          ],
          [
            "Sooji (Semolina)",
            "2 tbsp"
          ],
          [
            "தயிர்",
            "3 tbsp"
          ],
          [
            "Baking Powder & Soda",
            "1/2 tsp & 1/4 tsp"
          ],
          [
            "உப்பு",
            "1/2 tsp each"
          ],
          [
            "எண்ணெய்",
            "3 cups"
          ]
        ],
        "quick_ta": "மைதா, ரவை, தயிர், பேக்கிங் பவுடர் சேர்த்து பிசைந்து 2 மணி நேரம் ஊறவைக்கவும்|தடிமனான வட்டமாக தேய்த்து சூடான எண்ணெயில் உப்பி பொன்னிறமாக பொரித்தெடுக்கவும்"
      },
      {
        "name_ta": "அமிர்தசரஸ் சோலே மசாலா",
        "ingredients_ta": [
          [
            "Kabuli Chana (Chickpeas soaked overnight)",
            "1.5 cups"
          ],
          [
            "தக்காளி",
            "2 chopped & 2 pureed"
          ],
          [
            "பூண்டு",
            "1.5 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "Amchur (Dry Mango Powder)",
            "1 tsp"
          ],
          [
            "Tea Bag (for dark color)",
            "1 pc"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "கஸ்தூரி மேத்தி",
            "1 tsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "கொண்டைக்கடலையை டீ பேக் சேர்த்து வேகவைக்கவும்|நெய்யில் வெங்காயம், இஞ்சி பூண்டு, தக்காளி, சோலே மசாலா வதக்கி வெந்த கொண்டைக்கடலை சேர்த்து 10 நிமிடம் கொதிக்கவிடவும்|இஞ்சி தாளித்து இறக்கவும்"
      }
    ]
  },
  "33": {
    "meal_ta": "மெக்ஸிகன் சீஸ் டகோஸ் + குவாக்கமோலி சாலட்",
    "desc_ta": "மொறுமொறுப்பான டகோ கூட்டில் சீஸ், பீன்ஸ் மற்றும் அவகேடோ சல்சா.",
    "state_ta": "மெக்சிகோ",
    "cuisine_ta": "மெக்சிகன் உணவு",
    "dishes_ta": [
      {
        "name_ta": "சீஸ் மெக்சிகன் டகோஸ்",
        "ingredients_ta": [
          [
            "டகோ ஷெல் / ரொட்டி",
            "6 pcs"
          ],
          [
            "Beans (Cooked Rajma / Black Beans)",
            "1.5 cups seasoned with cumin & chilli"
          ],
          [
            "Cheese (shredded)",
            "1 cup"
          ],
          [
            "தக்காளி",
            "1 cup"
          ],
          [
            "Sour Cream / Yogurt Dip",
            "3 tbsp"
          ],
          [
            "தக்காளி சல்சா",
            "1/2 cup"
          ]
        ],
        "quick_ta": "டகோ ஷெல்களை அவனில் 3 நிமிடம் சூடாக்கவும்|கார பீன்ஸ், சல்சா, சீஸ், லெட்டூஸ் உள்ளே வைக்கவும்"
      },
      {
        "name_ta": "அவகேடோ குவாக்காமோல்",
        "ingredients_ta": [
          [
            "வெண்ணெய் பழம் (அவகேடோ)",
            "2 pcs"
          ],
          [
            "Lime Juice",
            "1 tbsp"
          ],
          [
            "தக்காளி",
            "2 tbsp each"
          ],
          [
            "கொத்தமல்லி",
            "1 tbsp & 1/2 tsp"
          ]
        ],
        "quick_ta": "அவகேடோவை மசித்து வெங்காயம், தக்காளி, எலுமிச்சை சாறு, உப்பு சேர்த்து கலக்கவும்"
      }
    ]
  },
  "34": {
    "meal_ta": "மொறுமொறு வெங்காய பக்கோடா + இஞ்சி ஏலக்காய் டீ",
    "desc_ta": "மழைக்காலத்திற்கு இதமான மொறுமொறு வெங்காய பக்கோடா மற்றும் சுடச்சுட மசாலா டீ.",
    "state_ta": "தமிழ்நாடு / தென்னிந்தியா",
    "cuisine_ta": "மாலை நேர டீ ஸ்நாக்ஸ்",
    "dishes_ta": [
      {
        "name_ta": "மொறுமொறு வெங்காய பக்கோடா",
        "ingredients_ta": [
          [
            "வெங்காயம்",
            "3 large"
          ],
          [
            "Besan (Gram Flour)",
            "1 cup"
          ],
          [
            "அரிசி",
            "3 tbsp"
          ],
          [
            "சோம்பு (பெருஞ்சீரகம்)",
            "1 tsp"
          ],
          [
            "இஞ்சி",
            "finely chopped"
          ],
          [
            "பெருங்காயம்",
            "1 tsp & 1/4 tsp"
          ],
          [
            "எண்ணெய்",
            "1 tbsp"
          ],
          [
            "எண்ணெய்",
            "2 cups"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "வெங்காயத்துடன் மசாலா தூள்கள், உப்பு சேர்த்து பிசைந்து தண்ணீர் சேர்க்காமல் கடலைமாவு, அரிசிமாவு, சூடான எண்ணெய் தெளித்து பிசையவும்|சூடான எண்ணெயில் பொன்னிறமாக பொரித்தெடுக்கவும்"
      },
      {
        "name_ta": "ஏலக்காய் இஞ்சி மசாலா டீ",
        "ingredients_ta": [
          [
            "பால்",
            "1 cup & 1 cup"
          ],
          [
            "Strong Tea Dust / Leaves",
            "2 tsp"
          ],
          [
            "இஞ்சி",
            "1 inch"
          ],
          [
            "Green Cardamom (crushed)",
            "3 pods"
          ],
          [
            "Sugar",
            "2 tsp"
          ]
        ],
        "quick_ta": "தண்ணீரில் இஞ்சி, ஏலக்காய், தேயிலை சேர்த்து கொதிக்கவைத்து பால், சர்க்கரை சேர்த்து வடிகட்டவும்"
      }
    ]
  },
  "35": {
    "meal_ta": "கன்னியாகுமரி தேங்காய் மீன் குழம்பு + மட்ட அரிசி சாதம்",
    "desc_ta": "வறுத்தரைத்த தேங்காய் மற்றும் குடம்புளி மணக்கும் குமரி மாவட்ட மீன் குழம்பு.",
    "state_ta": "தமிழ்நாடு / கேரளா",
    "cuisine_ta": "கன்னியாகுமரி கடலோர உணவு",
    "dishes_ta": [
      {
        "name_ta": "கன்னியாகுமரி தேங்காய் மீன் குழம்பு",
        "ingredients_ta": [
          [
            "மீன்",
            "500g"
          ],
          [
            "சீரகம்",
            "1 cup & 1 tsp ground to smooth paste"
          ],
          [
            "சின்ன வெங்காயம்",
            "12 & 6 cloves"
          ],
          [
            "தக்காளி",
            "2 chopped"
          ],
          [
            "புளிக்கரைசல்",
            "3 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "2 tbsp & 1.5 tbsp"
          ],
          [
            "கடுகு",
            "1/2 tsp each"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "2 sprigs"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "தேங்காய், சீரகம், சின்ன வெங்காயம் நைசாக அரைக்கவும்|மண்பானையில் தேங்காய் எண்ணெயில் கடுகு, வெந்தயம், சின்ன வெங்காயம், தக்காளி, புளிச்சாறு, தேங்காய் விழுது சேர்த்து கொதிக்கவிடவும்|மீன் துண்டுகளை சேர்த்து 6 நிமிடம் மிதமான தீயில் வேகவிடவும்"
      },
      {
        "name_ta": "நாகர்கோவில் மீன் வறுவல்",
        "ingredients_ta": [
          [
            "மீன்",
            "300g"
          ],
          [
            "Red Chilli Powder & Pepper",
            "1.5 tsp & 1/2 tsp"
          ],
          [
            "பூண்டு",
            "1 tsp & 1 tbsp"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "மீனில் மிளகாய், இஞ்சி பூண்டு, எலுமிச்சை சாறு தடவி தேங்காய் எண்ணெயில் இருபுறமும் சிவக்க வறுக்கவும்"
      },
      {
        "name_ta": "கேரளா மட்ட அரிசி சாதம்",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தண்ணீர்",
            "5 cups"
          ]
        ],
        "quick_ta": "மட்ட அரிசியை குக்கரில் 5 விசில் வரை வேகவைத்து வடிக்கவும்"
      }
    ]
  },
  "36": {
    "meal_ta": "கேரளா மீன் பொள்ளിച്ചത് (வாழை இலை மீன்) + சாதம்",
    "desc_ta": "வாழை இலையில் மசாலா தடவி சுட்ட பாரம்பரிய கேரளா கறிமீன் பொள்ளിച്ചത്.",
    "state_ta": "கேரளா",
    "cuisine_ta": "கேரளா கடல் உணவு",
    "dishes_ta": [
      {
        "name_ta": "வாழை இலை மீன் பொள்ளிச்சது",
        "ingredients_ta": [
          [
            "மீன்",
            "2 whole/steaks"
          ],
          [
            "சின்ன வெங்காயம்",
            "1.5 cups"
          ],
          [
            "பூண்டு",
            "1.5 tbsp each"
          ],
          [
            "தக்காளி",
            "2 medium"
          ],
          [
            "பச்சை மிளகாய்",
            "2 sprigs & 3 slit"
          ],
          [
            "கொத்தமல்லி",
            "1.5 tsp, 1/2 tsp, 1 tsp"
          ],
          [
            "Kudampuli (Malabar Tamarind) / Lemon",
            "1 piece / 1 tbsp"
          ],
          [
            "Fresh Banana Leaves",
            "2 softened over fire"
          ],
          [
            "எண்ணெய்",
            "3 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "மீனில் மசாலா தடவி தேங்காய் எண்ணெயில் லேசாக வறுக்கவும்|வெங்காயம், தக்காளி, இஞ்சி பூண்டு மசாலா வதக்கவும்|வாழை இலையில் மசாலா மற்றும் மீன் வைத்து மடித்து தவா வில் தேங்காய் எண்ணெய் விட்டு இருபுறமும் 5 நிமிடம் சுட்டெடுக்கவும்"
      },
      {
        "name_ta": "சுடு சோறு",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தண்ணீர்",
            "3.5 cups"
          ]
        ],
        "quick_ta": "சாதத்தை சூடாக வேகவைத்து பரிமாறவும்"
      }
    ]
  },
  "37": {
    "meal_ta": "கேரளா பஞ்சு ஆப்பம் + காய்கறி தேங்காய்ப்பால் கறி",
    "desc_ta": "கேரளா ஸ்பெஷல் ஆப்பம் மற்றும் தேங்காய்ப்பால் அவியல் குருமா.",
    "state_ta": "கேரளா",
    "cuisine_ta": "கேரளா பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "சுடச்சுட ஆப்பம் (பாலப்பம்)",
        "ingredients_ta": [
          [
            "அரிசி",
            "2 cups soaked"
          ],
          [
            "துருவிய தேங்காய்",
            "1 cup"
          ],
          [
            "அரிசி",
            "1/2 cup"
          ],
          [
            "ஈஸ்ட்",
            "1/2 tsp"
          ],
          [
            "உப்பு",
            "1 tbsp & 1 tsp"
          ]
        ],
        "quick_ta": "பச்சரிசி, தேங்காய், சாதம் சேர்த்து அரைத்து புளிக்க வைக்கவும்|ஆப்பச்சட்டியில் மாவை ஊற்றி சுழற்றி மூடி 2 நிமிடம் வேகவைக்கவும்"
      },
      {
        "name_ta": "தேங்காய்ப்பால் காய்கறி ஸ்டூ",
        "ingredients_ta": [
          [
            "உருளைக்கிழங்கு",
            "2 cups diced"
          ],
          [
            "தேங்காய்ப்பால்",
            "2 cups & 1 cup"
          ],
          [
            "வெங்காயம்",
            "1 sliced, 1 tbsp minced, 3 slit"
          ],
          [
            "Cinnamon, Cardamom, Cloves",
            "1 inch, 3 pods, 4 pcs"
          ],
          [
            "கறிவேப்பிலை",
            "1.5 tbsp & 2 sprigs"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "தேங்காய் எண்ணெயில் பட்டை கிராம்பு, இஞ்சி, மிளகாய் வதக்கி காய்கறிகள் மற்றும் இரண்டாம் தேங்காய்ப்பால் சேர்த்து வேகவிடவும்|கெட்டி தேங்காய்ப்பால் மற்றும் கறிவேப்பிலை சேர்த்து சூடாக்கி இறக்கவும்"
      }
    ]
  },
  "38": {
    "meal_ta": "மலபார் முட்டை ரோஸ்ட் + மெதுவான ஆப்பம்",
    "desc_ta": "வெங்காயம் தக்காளி மசாலாவில் பிரட்டிய காரசாரமான மலபார் முட்டை கறி.",
    "state_ta": "கேரளா / தமிழ்நாடு",
    "cuisine_ta": "கேரளா அசைவ காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "சுடச்சுட ஆப்பம் (பாலப்பம்)",
        "ingredients_ta": [
          [
            "Appam Batter",
            "2 cups"
          ],
          [
            "உப்பு",
            "1/2 tsp each"
          ]
        ],
        "quick_ta": "ஆப்பச்சட்டியில் மாவை ஊற்றி சுழற்றி மூடி வைத்து 2 நிமிடம் வேகவிடவும்"
      },
      {
        "name_ta": "மலபார் முட்டை ரோஸ்ட்",
        "ingredients_ta": [
          [
            "முட்டை",
            "4 slit lengthwise"
          ],
          [
            "வெங்காயம்",
            "2.5 cups"
          ],
          [
            "தக்காளி",
            "2 large"
          ],
          [
            "பூண்டு",
            "1.5 tbsp"
          ],
          [
            "சோம்பு (பெருஞ்சீரகம்)",
            "1 tsp"
          ],
          [
            "கொத்தமல்லி",
            "1.5 tbsp & 1 tbsp"
          ],
          [
            "மிளகு",
            "1/2 tsp & 1/2 tsp"
          ],
          [
            "கறிவேப்பிலை",
            "2 sprigs & 2 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "தேங்காய் எண்ணெயில் வெங்காயம் பொன்னிறமாக வதக்கி இஞ்சி பூண்டு, மசாலா, தக்காளி சேர்த்து வதக்கவும்|அவித்த முட்டைகளை கீறி சேர்த்து மசாலா நன்கு படியும் வரை 4 நிமிடம் வதக்கவும்"
      }
    ]
  },
  "39": {
    "meal_ta": "கேரளா புட்டு + கடலைக்கறி + பப்படம்",
    "desc_ta": "ஆவியில் வெந்த அரிசி மாவு புட்டு மற்றும் காரசாரமான கருப்பு கொண்டைக்கடலை கறி.",
    "state_ta": "கேரளா / தமிழ்நாடு",
    "cuisine_ta": "கேரளா பாரம்பரியம்",
    "dishes_ta": [
      {
        "name_ta": "மல்லிகைப் பூ அரிசி புட்டு",
        "ingredients_ta": [
          [
            "அரிசி",
            "2 cups"
          ],
          [
            "துருவிய தேங்காய்",
            "1 cup"
          ],
          [
            "உப்பு",
            "3/4 cup & 1/2 tsp"
          ]
        ],
        "quick_ta": "புட்டு மாவில் உப்பு தண்ணீர் தெளித்து புட்டுக்குழலில் தேங்காய் துருவலுடன் மாற்றி மாற்றி நிரப்பவும்|ஆவியில் 6-8 நிமிடம் வேகவைத்து வெளியே தள்ளவும்"
      },
      {
        "name_ta": "காரசார கடலைக் கறி",
        "ingredients_ta": [
          [
            "Black Chickpeas (Kadala soaked overnight)",
            "1.5 cups"
          ],
          [
            "துருவிய தேங்காய்",
            "1 cup coconut, fennel, coriander roasted dark brown & ground to paste"
          ],
          [
            "சின்ன வெங்காயம்",
            "finely chopped"
          ],
          [
            "தக்காளி",
            "1 chopped"
          ],
          [
            "கறிவேப்பிலை",
            "for tempering"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "வறுத்த தேங்காய் விழுது அரைத்து வேகவைத்த கருப்பு கொண்டைக்கடலையுடன் சேர்த்து கொதிக்கவிடவும்|கடுகு, கறிவேப்பிலை தாளிக்கவும்"
      }
    ]
  },
  "40": {
    "meal_ta": "கேரளா அவியல் + மட்ட அரிசி + மோர் குழம்பு",
    "desc_ta": "தேங்காய் சீரகம் மணக்கும் பாரம்பரிய 10 காய்கறி அவியல் மற்றும் குளிர்ந்த மோர் குழம்பு.",
    "state_ta": "கேரளா / தமிழ்நாடு",
    "cuisine_ta": "கேரளா சத்யா விருந்து",
    "dishes_ta": [
      {
        "name_ta": "கேரளா பாரம்பரிய அவியல்",
        "ingredients_ta": [
          [
            "முட்டை",
            "3 cups cut into 2-inch batons"
          ],
          [
            "சீரகம்",
            "1.5 cups & 1 tsp coarsely ground"
          ],
          [
            "பச்சை மிளகாய்",
            "4 slit"
          ],
          [
            "தயிர்",
            "1/3 cup"
          ],
          [
            "கறிவேப்பிலை",
            "2 tbsp & 3 sprigs"
          ],
          [
            "மஞ்சள் தூள்",
            "1/2 tsp"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "காய்கறிகளை மஞ்சள் தூள், உப்பு, பச்சை மிளகாய் சேர்த்து வேகவைக்கவும்|தேங்காய் சீரகம் அரைத்து சேர்க்கவும்|தயிர் சேர்த்து மிதமான தீயில் கிளறி பச்சை தேங்காய் எண்ணெய் மற்றும் கறிவேப்பிலை ஊற்றி மூடி வைக்கவும்"
      },
      {
        "name_ta": "தாளித்த மோர்க்குழம்பு",
        "ingredients_ta": [
          [
            "தயிர்",
            "2 cups"
          ],
          [
            "சின்ன வெங்காயம்",
            "minced"
          ],
          [
            "கறிவேப்பிலை",
            "for tadka"
          ],
          [
            "எண்ணெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1/4 tsp & 1/2 tsp"
          ]
        ],
        "quick_ta": "தயிரில் மஞ்சள், உப்பு கலக்கவும்|தேங்காய் எண்ணெயில் கடுகு, வெந்தயம், வெங்காயம் தாளித்து தயிரை ஊற்றி மிதமான சூட்டில் கிளறி இறக்கவும்"
      },
      {
        "name_ta": "சுடு சோறு",
        "ingredients_ta": [
          [
            "அரிசி",
            "1.5 cups"
          ],
          [
            "தண்ணீர்",
            "3.5 cups"
          ]
        ],
        "quick_ta": "சிவப்பு அரிசி சாதத்தை மென்மையாக வடிக்கவும்"
      }
    ]
  },
  "41": {
    "meal_ta": "பன்னீர் புர்ஜி + கோதுமை ஃபுல்கா",
    "desc_ta": "உதிர்த்த பன்னீருடன் வெங்காயம் தக்காளி மசாலா வதக்கிய புரதச்சத்து புர்ஜி.",
    "state_ta": "வட இந்தியா",
    "cuisine_ta": "அதிக புரத இரவு உணவு",
    "dishes_ta": [
      {
        "name_ta": "பன்னீர் புர்ஜி",
        "ingredients_ta": [
          [
            "பன்னீர்",
            "300g"
          ],
          [
            "வெங்காயம்",
            "2 medium"
          ],
          [
            "தக்காளி",
            "2 & 1/2 cup chopped"
          ],
          [
            "இஞ்சி",
            "2 minced & 1 tbsp minced"
          ],
          [
            "Turmeric, Kasuri Methi, Garam Masala",
            "1/2 tsp, 1 tsp, 1/2 tsp"
          ],
          [
            "நெய்",
            "2 tbsp"
          ],
          [
            "கொத்தமல்லி",
            "handful"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "வெண்ணெயில் இஞ்சி, மிளகாய், வெங்காயம், தக்காளி, குடைமிளகாய் வதக்கவும்|உதிர்த்த பன்னீர் சேர்த்து 3 நிமிடம் கிளறி கசூரி மேத்தி தூவவும்"
      },
      {
        "name_ta": "கோதுமை புல்கா ரொட்டி",
        "ingredients_ta": [
          [
            "கோதுமை மாவு",
            "2 cups"
          ],
          [
            "தண்ணீர்",
            "3/4 cup"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "கோதுமை மாவை பிசைந்து மெல்லியதாக தேய்த்து தவா மற்றும் தீயில் உப்ப வைக்கவும்"
      }
    ]
  },
  "42": {
    "meal_ta": "தாளித்த சுண்டல் + ஏலக்காய் மசாலா டீ",
    "desc_ta": "தாளித்த வெள்ளை கொண்டைக்கடலை சுண்டல் மற்றும் சுடச்சுட மாலை டீ.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "கோவில் பலகாரம்",
    "dishes_ta": [
      {
        "name_ta": "கொண்டைக்கடலை சுண்டல்",
        "ingredients_ta": [
          [
            "எண்ணெய்",
            "2 cups"
          ],
          [
            "துருவிய தேங்காய்",
            "1/2 cup"
          ],
          [
            "உளுத்தம் பருப்பு",
            "1 tsp & 1 tsp"
          ],
          [
            "பச்சை மிளகாய்",
            "2 pcs & 1 slit"
          ],
          [
            "இஞ்சி",
            "1/4 tsp & 1 tsp minced"
          ],
          [
            "கறிவேப்பிலை",
            "2 sprigs"
          ],
          [
            "எண்ணெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "எண்ணெயில் கடுகு, உளுந்து, வரமிளகாய், பெருங்காயம், கறிவேப்பிலை தாளிக்கவும்|வேகவைத்த கொண்டைக்கடலை சேர்த்து 2 நிமிடம் கிளறி துருவிய தேங்காய் தூவவும்"
      },
      {
        "name_ta": "ஏலக்காய் இஞ்சி மசாலா டீ",
        "ingredients_ta": [
          [
            "பால்",
            "1 cup each"
          ],
          [
            "Tea Powder",
            "2 tsp"
          ],
          [
            "இஞ்சி",
            "crushed"
          ],
          [
            "Sugar",
            "2 tsp"
          ]
        ],
        "quick_ta": "இஞ்சி, ஏலக்காய் சேர்த்து மசாலா டீ கொதிக்கவைத்து வடிகட்டவும்"
      }
    ]
  },
  "43": {
    "meal_ta": "வேகவைத்த முட்டை மிளகு மசாலா + சப்பாத்தி",
    "desc_ta": "மிளகு சீரக மசாலாவில் பிரட்டிய முட்டை வறுவல் மற்றும் மிருதுவான சப்பாத்தி.",
    "state_ta": "தமிழ்நாடு / தென்னிந்தியா",
    "cuisine_ta": "மிலிட்டரி மெஸ் அசைவம்",
    "dishes_ta": [
      {
        "name_ta": "செட்டிநாடு முட்டை மிளகு வறுவல்",
        "ingredients_ta": [
          [
            "முட்டை",
            "4 halved"
          ],
          [
            "வெங்காயம்",
            "1 cup finely chopped"
          ],
          [
            "மிளகு",
            "1.5 tbsp"
          ],
          [
            "Fennel Seeds & Cumin",
            "1 tsp each"
          ],
          [
            "பூண்டு",
            "1 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "2 sprigs"
          ],
          [
            "எண்ணெய்",
            "2 tbsp"
          ],
          [
            "உப்பு",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_ta": "நல்லெண்ணெயில் சோம்பு, கறிவேப்பிலை, சின்ன வெங்காயம், இஞ்சி பூண்டு வதக்கவும்|அவித்த முட்டைகளை இரண்டாக நறுக்கி சேர்த்து தாராளமாக மிளகுத்தூள் தூவி 3 நிமிடம் சிவக்க வறுக்கவும்"
      },
      {
        "name_ta": "மெதுவான கோதுமை சப்பாத்தி",
        "ingredients_ta": [
          [
            "கோதுமை மாவு",
            "2 cups"
          ],
          [
            "தண்ணீர்",
            "3/4 cup"
          ],
          [
            "நெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1/2 tsp"
          ]
        ],
        "quick_ta": "கோதுமை மாவில் மெதுவான சப்பாத்தி சுட்டெடுக்கவும்"
      }
    ]
  },
  "44": {
    "meal_ta": "குதிரைவாலி தினை பொங்கல் + கீரை கூட்டு",
    "desc_ta": "உடலுக்கு ஆரோக்கியம் தரும் சிறுதானிய குதிரைவாலி நெய் பொங்கல் மற்றும் பாசிப்பருப்பு கீரை கூட்டு.",
    "state_ta": "தமிழ்நாடு",
    "cuisine_ta": "சத்துமிக்க சிறுதானிய உணவு",
    "dishes_ta": [
      {
        "name_ta": "குதிரைவாலி நெய் பொங்கல்",
        "ingredients_ta": [
          [
            "Barnyard Millet (Kuthiraivali)",
            "1 cup"
          ],
          [
            "பாசிப்பருப்பு",
            "1/2 cup"
          ],
          [
            "நெய்",
            "3 tbsp"
          ],
          [
            "மிளகு",
            "1 tbsp each"
          ],
          [
            "இஞ்சி",
            "1 tbsp & 10 pcs"
          ],
          [
            "கறிவேப்பிலை",
            "1 sprig & 1/4 tsp"
          ],
          [
            "தண்ணீர்",
            "4.5 cups"
          ],
          [
            "உப்பு",
            "1.5 tsp"
          ]
        ],
        "quick_ta": "குதிரைவாலி மற்றும் பாசிப்பருப்பை குழைய வேகவைக்கவும்|நெய்யில் முந்திரி, மிளகு, சீரகம், இஞ்சி, கறிவேப்பிலை தாளித்துக் கொட்டவும்"
      },
      {
        "name_ta": "கீரை பருப்புக் கூட்டு",
        "ingredients_ta": [
          [
            "Fresh Spinach / Araikeerai / Palak",
            "2 cups chopped"
          ],
          [
            "துவரம் பருப்பு",
            "1/2 cup boiled"
          ],
          [
            "துருவிய தேங்காய்",
            "1/3 cup coconut & 1 tsp cumin ground"
          ],
          [
            "காய்ந்த மிளகாய்",
            "1 tsp & 1 pc"
          ],
          [
            "நெய்",
            "1 tbsp"
          ],
          [
            "உப்பு",
            "1/4 tsp & 1 tsp"
          ]
        ],
        "quick_ta": "கீரை, வெந்த பருப்பு, தேங்காய் சீரக விழுது சேர்த்து வேகவைத்து நெய்யில் கடுகு, காய்ந்த மிளகாய் தாளிக்கவும்"
      }
    ]
  },
  "45": {
    "meal_ta": "காய்கறி ஓட்ஸ் உப்புமா + தேங்காய் சட்னி",
    "desc_ta": "நார்ச்சத்து நிறைந்த காய்கறி ஓட்ஸ் மற்றும் சுவையான தேங்காய் சட்னி.",
    "state_ta": "பாரம்பரிய ஆரோக்கியம்",
    "cuisine_ta": "நார்ச்சத்து நிறைந்த காலை உணவு",
    "dishes_ta": [
      {
        "name_ta": "காய்கறி ஓட்ஸ் உப்புமா",
        "ingredients_ta": [
          [
            "ஓட்ஸ்",
            "1.5 cups"
          ],
          [
            "Carrots, Green Beans, Green Peas",
            "1 cup finely diced"
          ],
          [
            "வெங்காயம்",
            "1 chopped, 1 tsp minced, 2 slit"
          ],
          [
            "உளுத்தம் பருப்பு",
            "1 tsp & 1 tsp"
          ],
          [
            "முந்திரி",
            "8 pcs"
          ],
          [
            "நெய்",
            "1.5 tbsp"
          ],
          [
            "கறிவேப்பிலை",
            "for garnish"
          ],
          [
            "தண்ணீர்",
            "2 cups"
          ],
          [
            "உப்பு",
            "1 tsp"
          ]
        ],
        "quick_ta": "ஓட்ஸை வறுத்து வைக்கவும்|எண்ணெயில் கடுகு, உளுந்து, இஞ்சி, காய்கறிகள் வதக்கி தண்ணீர் சேர்த்து கொதித்ததும் ஓட்ஸ் சேர்த்து 3 நிமிடம் கிளறி வேகவிடவும்"
      },
      {
        "name_ta": "கெட்டி தேங்காய் சட்னி",
        "ingredients_ta": [
          [
            "துருவிய தேங்காய்",
            "1 cup"
          ],
          [
            "Roasted Gram",
            "2 tbsp"
          ],
          [
            "Green Chilli",
            "2"
          ],
          [
            "உப்பு",
            "for taste"
          ]
        ],
        "quick_ta": "தேங்காய், பொட்டுக்கடலை, மிளகாய் அரைத்து கடுகு கறிவேப்பிலை தாளிக்கவும்"
      }
    ]
  },
  46: {
    "meal_ta": "மதுரை கறி தோசை (மட்டன் கீமா தோசை)",
    "desc_ta": "மதுரையின் உலகப் புகழ்பெற்ற கறி தோசை — பஞ்சு போன்ற தடிமனான தோசை மீது முட்டை மற்றும் காரசாரமான கொத்துக்கறி (மட்டன் சுக்கா கீமா) சேர்த்து வார்க்கப்படும் அதிரடி சுவை!",
    "state_ta": "தமிழ்நாடு",
    "dishes_ta": [
      {
        "name_ta": "மதுரை மட்டன் கீமா சுக்கா",
        "ingredients_ta": [
          ["மட்டன் கொத்துக்கறி (கீமா)", "250g"],
          ["சின்ன வெங்காயம்", "1 cup chopped"],
          ["இஞ்சி பூண்டு விழுது", "1 tbsp"],
          ["சோம்பு", "1 tsp"],
          ["மிளகுத்தூள்", "1.5 tsp"],
          ["மஞ்சள்தூள் மற்றும் மிளகாய்த்தூள்", "1 tsp each"],
          ["கறிவேப்பிலை", "2 sprigs"],
          ["நல்லெண்ணெய்", "2 tbsp"],
          ["உப்பு", "1 tsp"]
        ],
        "quick_ta": "நல்லெண்ணெயில் சோம்பு, வெங்காயம், இஞ்சி-பூண்டு, மசாலா வதக்கி கொத்துக்கறி சேர்த்து தண்ணீர் வற்றும் வரை 15 நிமிடம் சுருள வதக்கவும்"
      },
      {
        "name_ta": "முட்டை மற்றும் கீமா கறி தோசை",
        "ingredients_ta": [
          ["தோசை மாவு", "2 cups"],
          ["நாட்டுக்கோழி முட்டை", "3 beaten"],
          ["நெய் / நல்லெண்ணெய்", "3 tbsp"],
          ["கொத்தமல்லி மற்றும் மிளகுத்தூள்", "for garnish"]
        ],
        "quick_ta": "தோசைக் கல்லில் தடிமனாக மாவு ஊற்றி, மேலே முட்டை கலவை மற்றும் மட்டன் கீமாவை பரப்பி நெய் விட்டு இருபுறமும் சிவக்க வேக வைக்கவும்"
      }
    ]
  },
  47: {
    "meal_ta": "செட்டிநாடு சிக்கன் சுக்கா (காரைக்குடி சிக்கன் வறுவல்)",
    "desc_ta": "புதிதாக வறுத்து அரைத்த செட்டிநாட்டு மசாலா, கல்பாசி, சின்ன வெங்காயம் மற்றும் கறிவேப்பிலை மணத்துடன் நல்லெண்ணெயில் சுருள வறுத்த செட்டிநாடு கோழி வறுவல்!",
    "state_ta": "தமிழ்நாடு",
    "dishes_ta": [
      {
        "name_ta": "செட்டிநாடு வறுத்த மசாலாப் பொடி",
        "ingredients_ta": [
          ["மல்லி (தனியா)", "1.5 tbsp"],
          ["மிளகு", "1.5 tbsp"],
          ["சீரகம் மற்றும் சோம்பு", "1 tsp each"],
          ["காய்ந்த மிளகாய்", "5 pcs"],
          ["கல்பாசி", "1 small piece"],
          ["பட்டை மற்றும் கிராம்பு", "1 inch & 3 cloves"]
        ],
        "quick_ta": "முழு மசாலாப் பொருட்களை மிதமான தீயில் வறுத்து மணக்க மணக்க பொடியாக அரைத்து வைக்கவும்"
      },
      {
        "name_ta": "செட்டிநாடு சிக்கன் சுக்கா வறுவல்",
        "ingredients_ta": [
          ["சிக்கன் (கோழிக்கறி துண்டுகள்)", "500g"],
          ["சின்ன வெங்காயம்", "20 chopped"],
          ["இஞ்சி பூண்டு விழுது", "1.5 tbsp"],
          ["தக்காளி", "1 small chopped"],
          ["கறிவேப்பிலை", "3 sprigs"],
          ["நல்லெண்ணெய்", "3 tbsp"],
          ["உப்பு மற்றும் மஞ்சள்தூள்", "1 tsp & 1/2 tsp"]
        ],
        "quick_ta": "நல்லெண்ணெயில் வெங்காயம், இஞ்சி-பூண்டு வதக்கி சிக்கன் சேர்த்து வேக வைத்து, அரைத்த மசாலா சேர்த்து எண்ணெய் பிரிந்து சுக்கா ஆகும் வரை வறுக்கவும்"
      }
    ]
  },
  48: {
    "meal_ta": "திருநெல்வேலி அல்வா (பாரம்பரிய கோதுமை அல்வா)",
    "desc_ta": "திருநெல்வேலி தாமிரபரணி நீர் பெருமை வாய்ந்த பாரம்பரிய சம்பா கோதுமைப் பால் அல்வா — சுத்தமான பசு நெய், கேரமலைஸ் சர்க்கரை மற்றும் முந்திரி பருப்புடன் வாயில் கரையும் பளபளப்பான சுவை!",
    "state_ta": "தமிழ்நாடு",
    "dishes_ta": [
      {
        "name_ta": "சம்பா கோதுமைப் பால்",
        "ingredients_ta": [
          ["சம்பா முழு கோதுமை", "1 cup"],
          ["தண்ணீர்", "4 cups for extraction"]
        ],
        "quick_ta": "கோதுமையை 10 மணி நேரம் ஊறவைத்து அரைத்து மெல்லிய துணியில் வடிகட்டி கோதுமைப் பால் பிரித்தெடுக்கவும்"
      },
      {
        "name_ta": "நெய் மணக்கும் திருநெல்வேலி அல்வா",
        "ingredients_ta": [
          ["கெட்டி கோதுமைப் பால்", "1 cup"],
          ["சர்க்கரை", "2 cups"],
          ["சுத்தமான பசு நெய்", "1 cup"],
          ["முந்திரிப் பருப்பு", "15-20 pcs roasted in ghee"],
          ["ஏலக்காய்த்தூள்", "1/2 tsp"],
          ["கேரமல் சர்க்கரை (இயற்கை நிறத்திற்கு)", "2 tbsp sugar + 1 tbsp water"]
        ],
        "quick_ta": "சர்க்கரை பாகில் கோதுமைப் பால் சேர்த்து இடைவிடாமல் கிளறி, சிறிது சிறிதாக நெய் ஊற்றி அல்வா சுருண்டு வரும் போது வறுத்த முந்திரி சேர்த்து இறக்கவும்"
      }
    ]
  }
};

